import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../../Variables/Global";
import { FiEdit, FiTrash2, FiPlus } from 'react-icons/fi';
import ListCommercialInvoice from "../CommercialCustomerOrder/CommercialInvoices/ListCommercialInvoice";
import ListOrderProducts from "./Products/ListOrderProducts";
import Select from "react-select";
import axiosInstance from '../../../../api/axiosConfig';
import { Tabs, Tab, Alert, Badge } from 'react-bootstrap';
import { Card, CardBody, Table, Col, Row } from "reactstrap"
import Skeleton from 'react-loading-skeleton';
import { UncontrolledTooltip } from "reactstrap";
import Dropzone from "react-dropzone"
import { getDecodedToken } from '../../../../utils/utils';
import { formatDate } from "../../../../Classes/Util";

const ViewCustomerOrder = () => {
    var pId = useParams();
    var navigate = useNavigate();


    const trackingStatusStyles = {
        0: { color: '#292b2c', backgroundColor: '#e9eaea' },
        20: { color: '#292b2c', backgroundColor: '#e9eaea' },
        30: { color: '#292b2c', backgroundColor: '#d3d5d6' },
        35: { color: '#41b6d9', backgroundColor: '#eff9fc' },
        40: { color: '#936b16', backgroundColor: '#fdf0d3' },
        45: { color: '#35834f', backgroundColor: '#def8e6' },
        50: { color: '#197088', backgroundColor: '#d4f1f9' },
        60: { color: '#197088', backgroundColor: '#d4f1f9' },
    };

    const [customerName, setCustomerName] = useState("");
    const [permissions, setPermissions] = useState([]);

    const [showAdvancedDiscount, setShowAdvancedDiscount] = useState(false);
    const handleCloseAdvancedDiscount = () => setShowAdvancedDiscount(false);
    const handleShowAdvancedDiscount = () => setShowAdvancedDiscount(true);

    // Edit and delete advanced discount states
    const [showEditAdvancedDiscount, setShowEditAdvancedDiscount] = useState(false);
    const handleCloseEditAdvancedDiscount = () => setShowEditAdvancedDiscount(false);
    const handleShowEditAdvancedDiscount = () => setShowEditAdvancedDiscount(true);
    const [editingDiscount, setEditingDiscount] = useState({
        advancedDiscountId: 0,
        advancedDiscount: 0,
        discountDate: formatDate(new Date()),
        notes: "",
        orderId: pId.OrderId,
        proforma: "",
        userId: localStorage.getItem("uTsReD"),
        companyId: localStorage.getItem("C0m8N!"),
        customerAccountId: pId.AccountId,
        addToStatement: false
    });


    const [showAddCommercialInvoicePayment, setShowAddCommercialInvoicePayment] = useState(false);
    const handleCloseAddCommercialInvoicePayment = () => setShowAddCommercialInvoicePayment(false);
    const handleShowAddCommercialInvoicePayment = () => setShowAddCommercialInvoicePayment(true);
    const [showAddCommercialDiscount, setShowAddCommercialDiscount] = useState(false);
    const handleCloseAddCommercialDiscount = () => setShowAddCommercialDiscount(false);
    const handleShowAddCommercialDiscount = () => setShowAddCommercialDiscount(true);

    const [advancedDiscount, setAdvancedDiscount] = useState({
        advancedDiscount: 0,
        discountDate: formatDate(new Date()),
        notes: "",
        orderId: pId.OrderId,
        proforma: "",
        userId: localStorage.getItem("uTsReD"),
        companyId: localStorage.getItem("C0m8N!"),
        customerAccountId: pId.AccountId,
        addToStatement: false
    })

    const [commercialDiscount, setCommercialDiscount] = useState({
        commercialInvoiceNumber: "",
        remainingTotal: 0,
        commercialInvoiceId: 0,
        commercialInvoiceDiscount: 0,
        discountDate: formatDate(new Date()),
        notes: "",
        commercialInvoice: "",
        proforma: "",
        userId: localStorage.getItem("uTsReD"),
        addToStatement: false
    })

    const [commercialInvoicePayment, setCommercialInvoicePayment] = useState({
        commercialInvoiceId: 0,
        paymentValue: 0,
        paymentDate: formatDate(new Date()),
        notes: "",
        commercialInvoicePaymentBankId: 0,
        commercialInvoicePaymentBankAccountId: 0,
        bankAmount: 0,
        commercialInvoiceExchangeRate: 1,
        userId: localStorage.getItem("uTsReD"),
        invoiceNumber: "",
        remainingTotal: 0,
        commercialInvoiceNumber: "",
        customerOrderId: 0,
        customerId: pId.SupplierId,
        customerAccountId: pId.AccountId,
        customerName: "",
        customerAccountName: ""
    });

    const [showAddAdvancedPayment, setShowAddAdvancedPayment] = useState(false);
    const handleCloseAddAdvancedPayment = () => setShowAddAdvancedPayment(false);
    const handleShowAddAdvancedPayment = () => {
        // Reset form data to default values
        setAdvancedPayment({
            amount: 0,
            paymentPercentage: 0.0,
            date: formatDate(new Date()),
            notes: "",
            customerOrderId: pId.OrderId,
            bankId: 0,
            bankExchange: 1,
            bankAmount: 0,
            bankAccountId: 0,
            proforma: "",
            customerId: pId.CustomerId,
            userId: localStorage.getItem("uTsReD"),
            companyId: localStorage.getItem("C0m8N!"),
            customerAccountId: pId.AccountId,
            customerName: "",
            customerAccountName: ""
        });
        // Clear bank accounts and reset currency state
        setBankAccounts([]);
        setSameCurrency(true);
        setBankCurrency('');
        setShowAddAdvancedPayment(true);
    };
    const [advancedPayment, setAdvancedPayment] = useState({
        amount: 0,
        paymentPercentage: 0.0,
        date: formatDate(new Date()),
        notes: "",
        customerOrderId: pId.OrderId,
        bankId: 0,
        bankExchange: 1,
        bankAmount: 0,
        bankAccountId: 0,
        proforma: "",
        customerId: pId.CustomerId,
        userId: localStorage.getItem("uTsReD"),
        companyId: localStorage.getItem("C0m8N!"),
        customerAccountId: pId.AccountId,
        customerName: "",
        customerAccountName: ""
    })

    // Edit payment state variables
    const [showEditAdvancedPayment, setShowEditAdvancedPayment] = useState(false);
    const handleCloseEditAdvancedPayment = () => setShowEditAdvancedPayment(false);
    const handleShowEditAdvancedPayment = () => setShowEditAdvancedPayment(true);
    const [editingPayment, setEditingPayment] = useState({
        customerAdvancedPaymentId: 0,
        amount: 0,
        paymentPercentage: 0.0,
        date: formatDate(new Date()),
        notes: "",
        customerOrderId: pId.OrderId,
        bankId: 0,
        bankExchange: 1,
        bankAmount: 0,
        bankAccountId: 0,
        proforma: "",
        customerId: pId.CustomerId,
        userId: localStorage.getItem("uTsReD"),
        companyId: localStorage.getItem("C0m8N!"),
        customerAccountId: pId.AccountId,
        customerName: "",
        customerAccountName: ""
    });

    const [showEditCustomerOrder, setShowEditCustomerOrder] = useState(false);
    const handleCloseEditCustomerOrder = () => setShowEditCustomerOrder(false);
    const handleShowEditCustomerOrder = () => setShowEditCustomerOrder(true);
    const [showDeleteCustomerOrder, setShowDeleteCustomerOrder] = useState(false);
    const handleCloseDeleteCustomerOrder = () => setShowDeleteCustomerOrder(false);
    const handleShowDeleteCustomerOrder = () => setShowDeleteCustomerOrder(true);


    const [editingProductId, setEditingProductId] = useState(0);
    // const [showEditCustomerOrderProduct, setShowEditCustomerOrderProduct] = useState(false);
    // const handleCloseEditCustomerOrderProduct = () => setShowEditCustomerOrderProduct(false);
    // const handleShowEditCustomerOrderProduct = () => setShowEditCustomerOrderProduct(true);
    const [showDeleteCustomerOrderProduct, setShowDeleteCustomerOrderProduct] = useState(false);
    const handleCloseDeleteCustomerOrderProduct = () => setShowDeleteCustomerOrderProduct(false);
    const handleShowDeleteCustomerOrderProduct = () => setShowDeleteCustomerOrderProduct(true);
    const [deletingCustomerOrderProductId, setDeletingCustomerOrderProductId] = useState(0);


    const [showAddOrderProduct, setShowAddOrderProduct] = useState(false);
    const handleCloseAddOrderProduct = () => setShowAddOrderProduct(false);
    const handleShowAddOrderProduct = () => setShowAddOrderProduct(true);



    const [showAddCustomerCommercialInvoice, setShowAddCustomerCommercialInvoice] = useState(false);
    const handleShowAddCustomerCommercialInvoice = () => setShowAddCustomerCommercialInvoice(true);
    const handleCloseAddCustomerCommercialInvoice = () => setShowAddCustomerCommercialInvoice(false);

    const [showEditCommercialInvoice, setShowEditCommercialInvoice] = useState(false);

    const handleCloseEditCommercialInvoice = () => setShowEditCommercialInvoice(false);
    const handleShowEditCommercialInvoice = () => setShowEditCommercialInvoice(true);
    const [editingCommercialInvoiceId, setEditingCommercialInvoiceId] = useState(0);
    const [editingCommercialInvoice, setEditingCommercialInvoice] = useState({
        customerCommercialInvoice: "",
        userId: localStorage.getItem("uTsReD"),
        customerCommercialInvoiceDate: "",
        notes: "",
    })

    const [deletingCommercialInvoice, setDeletingCommercialInvoice] = useState("");
    const [deletingCommercialInvoiceId, setDeletingCommercialInvoiceId] = useState(0);
    const [showDeleteCommercialInvoice, setShowDeleteCommercialInvoice] = useState(false);
    const handleCloseDeleteCommercialInvoice = () => {
        setDeletingCommercialInvoiceId(0);
        setShowDeleteCommercialInvoice(false);
    }

    const [orderProduct, setOrderProduct] = useState({
        supplierOrderProductId: 0,
        customerOrderId: pId.OrderId,
        productQuantity: 0,
        fcl: 0,
        unitPrice: 0,
        supplierId: 0,
        userId: localStorage.getItem("uTsReD"),
        proforma: "",
        description: "",
        commissionPerFCL: 0.0,
        exchangeRate: 1.0,
        pendingFcl: 0,
        unit: ""
    });

    const [suppliers, setSuppliers] = useState([])
    const GetSuppliers = () => {
        var config = {
            method: 'get',
            url: "Supplier/GetCompanySuppliers/" + localStorage.getItem("C0m8N!"),
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                setSuppliers(response.data);
                // GetCustomerOrder(pId.OrderId);
            })
            .catch(function (error) {
                console.log(error);
                // GetCustomerOrder(pId.OrderId);
            });
    }

    const [orderTotal, setOrderTotal] = useState({
        orderProducts: "",
        otherCharges: "",
        totalAmount: "",
        orderAdvancedPayments: "",
        orderAdvancedDiscounts: "",
        dueTotal: ""
    });


    const GetCustomerOrderTotal = (orderId) => {
        var config = {
            method: 'get',
            url: "CustomerOrder/GetCustomerOrderTotals?customerOrderId=" + orderId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setOrderTotal(response.data);
                GetAdvancedPayments(pId.OrderId);
                // GetCustomerOrderProducts(orderId)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const handleSupplierChange = (supplierId) => {
        GetSupplierOrderProductBySupplierId(supplierId);
        setOrderProduct((prevState) => ({
            ...prevState,
            supplierId: supplierId,
            supplierOrderProductId: 0,
            description: ""
        }))
    }
    const [supplierOrderProducts, setSupplierOrderProducts] = useState([])
    const GetSupplierOrderProductBySupplierId = (supplierId) => {
        var config = {
            method: 'get',
            url: "SupplierOrderProduct/GetSupplierOrderProductBySupplierId/" + supplierId + "/Account/" + pId.AccountId + "/Currency/" + account.currencyId,
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                console.log(response.data)
                setSupplierOrderProducts(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [sameCurrency, setSameCurrency] = useState(true)

    const handleCustomerAccountOrderProduct = (e) => {

        var _description = "";
        var _unit = "";
        supplierOrderProducts.forEach(element => {
            if (element.supplierOrderProducts.supplierOrderProductId == e) {
                console.log(element)

                _description = " FCL, " + element.productName + ", " + element.productSizeName + ", " + element.productTypeName;
                _unit = element.productUnit1
            }
        });

        if (_description != "") {
            setOrderProduct((prevState) => ({
                ...prevState,
                description: _description,
                unit: _unit,
            }));
        }
    }

    const AddOrderProduct = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (validateOrderProductForm() == true) {
            var config = {
                method: 'post',
                url: "CustomerOrderProduct/AddCustomerOrderProduct/" + pId.AccountId,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: orderProduct
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        GetCustomerOrder(order.customerOrderId);
                        // props.GetCustomerOrderProductTotal(pId.OrderId);
                        toast.success("Added Successfully")
                        // setShowAddOrderProduct(false)
                        handleCloseAddOrderProduct();
                        setSubmitDisabled(false);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error(error.response.data)
                    handleCloseAddOrderProduct();
                    setSubmitDisabled(false);
                });
        }
        setSubmitDisabled(false);
    }

    const validateOrderProductForm = () => {

        if (orderProduct.supplierId == null || orderProduct.supplierId == 0) {
            toast.warn("Please select the supplier.");
            return false;
        }

        if (orderProduct.supplierOrderProductId == null || orderProduct.supplierOrderProductId == 0) {
            toast.warn("Please select the product.");
            return false;
        }

        if (editingProductId > 0) {

            if (orderProduct.fcl > (orderProduct.pendingFcl + orderProduct.oldFcl)) {
                toast.warn("Number of FCL should be less or equal to the product's available FCL.");
                return false;
            }
        }
        else {

            if (orderProduct.fcl > orderProduct.pendingFcl) {
                toast.warn("Number of FCL should be less or equal to the product's available FCL.");
                return false;
            }
        }
        if (orderProduct.fcl == 0 && orderProduct.pendingFcl > 0) {
            toast.warn("Number of FCL can't be zero.");
            return false;
        }

        if (orderProduct.productQuantity > orderProduct.pendingQuantity) {
            toast.warn("Quantity should be less or equal to the product's available quantity.");
            return false;
        }

        if (orderProduct.productQuantity === 0.0) {
            toast.warn("Quantity can't be zero.");
            return false;
        }

        if (orderProduct.fcl < 0) {
            toast.warn("Number of FCL can't be negative.");
            return false;
        }

        if (orderProduct.productQuantity < 0) {
            toast.warn("Quantity can't be negative.");
            return false;
        }

        if (orderProduct.unitPrice == null || orderProduct.unitPrice == 0) {
            toast.warn("Price can't be zero.");
            return false;
        }

        if (orderProduct.unitPrice < 0) {
            toast.warn("Price can't be negative.");
            return false;
        }

        return true;
    }

    const EditOrderProduct = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (validateOrderProductForm() == true) {
            var config = {
                method: 'put',
                url: "CustomerOrderProduct/EditCustomerOrderProduct/" + editingProductId,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: orderProduct
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        GetCustomerOrder(pId.OrderId);
                        // GetCustomerOrderProducts(pId.OrderId);
                        // props.GetCustomerOrderProductTotal(pId.OrderId);
                        toast.success("Updated Successfully")
                        // setShowAddOrderProduct(false)
                        handleCloseAddOrderProduct();
                        setSubmitDisabled(false);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error(error.response.data);
                    handleCloseAddOrderProduct();
                    setSubmitDisabled(false);
                });
        }
        setSubmitDisabled(false);
    }


    const DeleteCustomerOrder = () => {
        var config = {
            method: 'delete',
            url: "CustomerOrder/DeleteCustomerOrder/" + order.customerOrderId,
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                toast.success("Order deleted successfully.");
                handleCloseDeleteCustomerOrder();
                navigate(-1);
            })
            .catch(function (error) {
                console.log(error);
                handleCloseDeleteCustomerOrder();
                toast.error(error.response.data.message);
            });
    }

    const DeleteCustomerOrderProduct = () => {
        var config = {
            method: 'delete',
            url: "CustomerOrderProduct/DeleteCustomerOrderProduct/" + deletingCustomerOrderProductId,
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                GetCustomerOrder(order.customerOrderId);
                handleCloseDeleteCustomerOrderProduct();
                // props.setProducts(response.data)
                // setOrders(response.data);
                // GetCustomerOrderProducts(props.orderId);
            })
            .catch(function (error) {
                console.log(error);
                handleCloseDeleteCustomerOrderProduct();
                toast.error(error.response.data.message);
            });
    }


    const [editingOrder, setEditingOrder] = useState({
        // salesOrderId: 0,
        // payImmediately: false,
        invoiceNumber: "",
        otherCharges: "",
        notes: "",
        paymentTermsId: "",
        paymentTermsName: "",
        date: "",
        proformaFileURL: "",
        userId: localStorage.getItem("uTsReD"),
        companyId: localStorage.getItem("C0m8N!"),
        supplierAccountId: pId.AccountId,
    })

    const submitCustomerOrderForm = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (IsValidCustomerOrder()) {
            var config = {
                method: 'put',
                url: "CustomerOrder/EditCustomerOrder/" + pId.OrderId,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: editingOrder
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        setOrder(response.data);
                        // GetSupplierOrderTotal(pId.OrderId);
                        handleCloseEditCustomerOrder();
                        // navigate("/Accounting/Customer/" + pId.CustomerId + "/Account/" + pId.AccountId + "/Orders")
                        toast.success("Order Updated Successfully")
                        setSubmitDisabled(false);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error(error.response.data)
                    setSubmitDisabled(false);
                });
        }
        setSubmitDisabled(false);
    }

    const IsValidCustomerOrder = () => {
        if (editingOrder.invoiceNumber == "" && editingOrder.date == "") {
            toast.error("Enter all required fields");
            return false;
        }
        else if (editingOrder.invoiceNumber == "") {
            toast.error("Enter Country");
            return false;
        }
        else if (editingOrder.date == "") {
            toast.error("Enter Date");
            return false;
        }
        else if (editingOrder.paymentTermsId == null || editingOrder.paymentTermsId == 0) {
            toast.error("Select payment terms");
            return false;
        }
        return true;
    }



    // const [orderProducts, setOrderProducts] = useState([])
    // const GetOrderProducts = (orderId) => {
    //     var config = {
    //         method: 'get',
    //         url: "CustomerOrderProduct/GetCustomerOrderProduct/" + orderId,
    //         headers: {},
    //     };

    //     axiosInstance(config)
    //         .then(function (response) {
    //             setOrderProducts(response.data);
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }

    const [account, setAccount] = useState({
        customerAccountId: 0,
        customerAccount1: "",
        currencyId: 0
    })

    const [order, setOrder] = useState({
        customerOrderId: 0,
        customerOrder1: "",
        invoiceNumber: "",
        supplierInvoices: "",
        date: "",
    })



    const GetCustomer = (CustomerId) => {
        var config = {
            method: 'get',
            url: "Customer/GetCustomers/" + CustomerId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setCustomerName(response.data.customerName);
                setAdvancedPayment((prevState) => ({
                    ...prevState,
                    customerName: response.data.customerName
                }));
                GetCustomerAccount(pId.AccountId);
            })
            .catch(function (error) {
                console.log(error);
                GetCustomerAccount(pId.AccountId);
            });
    }
    const GetCustomerAccount = (accountId) => {
        var config = {
            method: 'get',
            url: "CustomerAccount/GetCustomerAccount/" + accountId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setAccount(response.data)
                setAdvancedPayment((prevState) => ({
                    ...prevState,
                    customerAccountName: response.data.customerAccount1
                }));
                GetCurrency(response.data.currencyId);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const [currency, setCurrency] = useState("");
    const GetCurrency = (currencyId) => {
        var config = {
            method: 'get',
            url: "Currency/GetCurrency/" + currencyId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setCurrency(response.data);
                GetCustomerOrder(pId.OrderId);
                GetCustomerAttachment(pId.OrderId);
                GetBanks();
                GetCustomerOrderTotal(pId.OrderId);
            })
            .catch(function (error) {
                console.log(error);
                GetCustomerOrder(pId.OrderId);
            });
    }

    const EditCustomerCommercialInvoice = (e) => {
        e.preventDefault();
        // if (validateForm() == true) {
        var config = {
            method: 'put',
            url: "CustomerCommercialInvoice/EditCustomerCommercialInvoice/" + editingCommercialInvoiceId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: editingCommercialInvoice
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    // GetCustomerOrderProducts(pId.OrderId);
                    GetCommercialInvoices(pId.OrderId);
                    toast.success("Edited Successfully")
                    setShowEditCommercialInvoice(false);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response.data)
            });
        // }
    }

    const submitDeleteInvoiceForm = (e) => {
        e.preventDefault();
        var config = {
            method: 'delete',
            url: "CustomerCommercialInvoice/DeleteCustomerCommercialInvoice/" + deletingCommercialInvoiceId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    GetCommercialInvoices(pId.OrderId);
                    toast.success("Invoice deleted Successfully")
                    setShowDeleteCommercialInvoice(false);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response.data)
            });
    }

    const GetCustomerOrder = (orderId) => {
        var config = {
            method: 'get',
            url: "CustomerOrder/GetCustomerOrder/" + orderId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setOrder(response.data);
                document.title = '#' + response.data.invoiceNumber;

                setAdvancedPayment((prevState) => ({
                    ...prevState,
                    proforma: response.data.invoiceNumber
                }));
                setAdvancedDiscount((prevState) => ({
                    ...prevState,
                    proforma: response.data.invoiceNumber
                }));
                // GetOrderProducts(pId.OrderId);
                GetCommercialInvoices(pId.OrderId);
                // GetCustomerOrderProductTotal(pId.OrderId);
            })
            .catch(function (error) {
                console.log(error);
                GetCommercialInvoices(pId.OrderId);
                // GetCustomerOrderProductTotal(pId.OrderId);
            });
    }

    const isValidCommercialInvoiceInfo = () => {
        if (customerCommercialInvoice.customerCommercialInvoice === "" || customerCommercialInvoice.customerCommercialInvoice === 0) {
            toast.error("Make sure to enter Customer Commercial Invoice");
            return false;
        }
        else if (customerCommercialInvoice.supplierCommercialInvoiceId === "" || customerCommercialInvoice.supplierCommercialInvoiceId === 0) {
            toast.error("Make sure to select Supplier Commercial Invoice");
            return false;
        }
        return true;
    }

    const AddCustomerCommercialInvoice = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (isValidCommercialInvoiceInfo()) {
            var config = {
                method: 'post',
                url: "CustomerCommercialInvoice/AddCustomerCommercialInvoice/" + pId.AccountId,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: customerCommercialInvoice
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        toast.success("Added Successfully");
                        GetCommercialInvoices(pId.OrderId);
                        handleCloseAddCustomerCommercialInvoice();
                        setSubmitDisabled(false);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error(error.response.data);
                    handleCloseAddCustomerCommercialInvoice();
                    setSubmitDisabled(false);
                });
        } else {
            setSubmitDisabled(false);
        }
    }

    const GetCommercialInvoices = (orderId) => {
        var config = {
            method: 'get',
            url: "CustomerCommercialInvoice/GetCustomerCommercialInvoicesWithDetails",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            params: {
                'OrderId': orderId
            }
        };

        axiosInstance(config)
            .then(function (response) {
                setCommercialInvoices(response.data);
                console.log(response.data);
                GetSupplierCommercialInvoices();
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response.data);
                GetSupplierCommercialInvoices();
            });
    }

    // const [orderTotal, setOrderTotal] = useState(0)
    // const GetCustomerOrderProductTotal = (orderId) => {
    //     var config = {
    //         method: 'get',
    //         url: "CustomerOrderProduct/GetCustomerCommercialInvoiceTotalPrice/" + orderId,
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Access-Control-Allow-Origin': Global.Host
    //         },
    //     };

    //     axiosInstance(config)
    //         .then(function (response) {
    //             console.log(response.data)
    //             setOrderTotal(response.data);

    //             GetCommercialInvoices(pId.OrderId);
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //             GetCommercialInvoices(pId.OrderId);
    //         });
    // }

    const [paymentTerms, setPaymentTerms] = useState([])
    const GetPaymentTerms = () => {
        var config = {
            method: 'get',
            url: "PaymentTerms/GetPaymentTerms/" + localStorage.getItem("C0m8N!"),
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                setPaymentTerms(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [show, setShow] = useState(false);

    const addCommercialInvoice = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [supplierCommercialInvoices, setSupplierCommercialInvoices] = useState([])
    const GetSupplierCommercialInvoices = () => {
        var config = {
            method: 'get',
            url: "SupplierCommercialInvoice/GetSupplierCommercialInvoicesByCustomerOrder/" + pId.OrderId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setSupplierCommercialInvoices(response.data)
                console.log(response.data)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [customerCommercialInvoice, setCustomerCommercialInvoice] = useState({
        customerCommercialInvoice: "",
        supplierCommercialInvoiceId: 0,
        customerOrderId: pId.OrderId,
        userId: localStorage.getItem("uTsReD"),
        customerCommercialInvoiceDate: (new Date()).toISOString().split('T')[0],//.substring(0, 10),
        notes: "",
    });

    // const AddCustomerCommercialInvoice = (e) => {
    //     e.preventDefault();
    //     var config = {
    //         method: 'post',
    //         url: "CustomerCommercialInvoice/AddCustomerCommercialInvoice/" + pId.AccountId,
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Access-Control-Allow-Origin': Global.Host
    //         },
    //         data: model
    //     };

    //     axiosInstance(config)
    //         .then(function (response) {
    //             if (response.status === 200) {
    //                 toast.success("Added Successfully")
    //                 GetCommercialInvoices(pId.OrderId);
    //                 setShow(false)
    //             }
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //             toast.error("Something Went Wrong")
    //         });
    // }

    const [advancedPayments, setAdvancedPayments] = useState([]);
    const [advancedDiscounts, setAdvancedDiscounts] = useState([]);
    const [orderAdvancedCharges, setOrderAdvancedCharges] = useState([]);
    const [commercialInvoices, setCommercialInvoices] = useState([]);
    // const GetCommercialInvoices = (orderId) => {
    //     var config = {
    //         method: 'get',
    //         url: 'CustomerCommercialInvoice/GetCustomerCommercialInvoice/' + orderId,
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //     };

    //     axiosInstance(config)
    //         .then(function (response) {
    //             console.log(response.data);
    //             setCustomerCommercialInvoice(response.data);
    //             GetSupplierCommercialInvoices();
    //         })
    //         .catch(function (error) {
    //             console.log(error);

    //             GetSupplierCommercialInvoices();
    //         });
    // }


    useEffect(() => {
        const decodedToken = getDecodedToken();
        const pJoin = JSON.stringify(JSON.parse(decodedToken.pJoin));
        var x = JSON.parse(pJoin);
        setPermissions(() => x);
        GetSuppliers();
        if (pId.OrderId !== "0") {
            GetCustomer(pId.CustomerId)
            GetShippingCostTypes();
        }
        else {
            navigate("/Accounting/Customer/View/" + pId.CustomerId)
        }
    }, [])



    const [banks, setBanks] = useState([]);
    const GetBanks = () => {
        var config = {
            method: 'get',
            url: "Bank/GetCompanyBanks/" + localStorage.getItem("C0m8N!"),
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setBanks(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const [bankAccounts, setBankAccounts] = useState([]);
    const GetBankAccounts = (bankId) => {
        var config = {
            method: 'get',
            url: "BankAccount/GetBankAccounts/" + bankId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        return axiosInstance(config)
            .then(function (response) {
                if (response.data.statusCode == 200) {
                    setBankAccounts(response.data.data);
                }
                return response;
            })
            .catch(function (error) {
                console.log(error);
                throw error;
            });
    }

    const [bankCurrency, setBankCurrency] = useState('')

    const reloadBankAmountCommercial = (originalPayment) => {
        var x = originalPayment;
        var y = commercialInvoicePayment.commercialInvoiceExchangeRate;
        var z = x * y;
        console.log(z)
        setCommercialInvoicePayment((prevState) => ({ ...prevState, bankAmount: z }))
    }

    const CalculateExchangeRateCommercial = (bankAmount) => {
        var x = bankAmount;
        var y = commercialInvoicePayment.paymentValue;
        var z = x / y;
        setCommercialInvoicePayment((prevState) => ({ ...prevState, commercialInvoiceExchangeRate: z }))
    }

    const CalculateBankAmountCommercial = (exchangeRate) => {
        var x = exchangeRate;
        var y = commercialInvoicePayment.paymentValue;
        var z = x * y;
        setCommercialInvoicePayment((prevState) => ({ ...prevState, bankAmount: z }))
    }

    const handleExchangeRate = (bankAmount) => {
        var x = advancedPayment.amount;
        var y = bankAmount;
        var z = y / x;
        setAdvancedPayment((prevState) => ({ ...prevState, bankExchange: z }))
    }

    const handleBankAmount = (rate) => {
        var x = advancedPayment.amount;
        var y = rate;
        var z = x * y;
        console.log(z)
        setAdvancedPayment((prevState) => ({ ...prevState, bankAmount: z }))
        console.log(advancedPayment)
    }

    const reloadBankAmount = (originalPayment) => {
        var percentage = originalPayment * 100.0 / orderTotal.remainingTotalAmount;
        var x = originalPayment;
        var y = advancedPayment.bankExchange;
        var z = x * y;
        console.log(z)
        setAdvancedPayment((prevState) => ({
            ...prevState,
            bankAmount: z,
            paymentPercentage: percentage
        }))
        console.log(advancedPayment)
    }

    const reloadAmountFromPercentage = (percentage) => {
        var originalPayment = orderTotal.remainingTotalAmount * percentage / 100.0;
        var x = originalPayment;
        var y = advancedPayment.bankExchange;
        var z = x * y;
        console.log(z)
        setAdvancedPayment((prevState) => ({
            ...prevState,
            amount: originalPayment,
            bankAmount: z,
        }))
        console.log(advancedPayment)
    }

    const [selectedFiles, setselectedFiles] = useState([])
    const handleAcceptedFiles = (acceptedFiles) => {
        //Mapped the preview before uploading 
        const mappedFiles = acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file),
            formattedSize: formatBytes(file.size)
        }));
        setselectedFiles(prevFiles => [...prevFiles, ...mappedFiles]);

        uploadFiles(acceptedFiles);
    };
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const uploadFiles = async (files) => {
        const companyCode = localStorage.getItem("C0m8N!");
        const userCode = localStorage.getItem("uTsReD");
        const customerOrderId = pId.OrderId;

        files.forEach(async (file) => {
            const formData = new FormData();
            formData.append('files', file);
            formData.append('companycode', companyCode);
            formData.append('usercode', userCode);
            formData.append('customerOrderId', customerOrderId);

            const config = {
                method: 'post',
                url: `${Global.API_URL}SupplierSalesOrder/Upload`,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: formData,
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress((prevProgress) => ({
                        ...prevProgress,
                        [file.name]: percentCompleted
                    }));
                }
            };

            try {
                const response = await axiosInstance(config);
                if (response.status === 200) {
                    toast.success(`Upload Succeed for ${file.name}`);
                    setUploadProgress((prevProgress) => ({
                        ...prevProgress,
                        [file.name]: 100
                    }));
                    GetCustomerAttachment(pId.OrderId);
                    console.log(`File successfully uploaded: ${file.name}`, response.data);
                }
            } catch (error) {
                console.error(`Error uploading file ${file.name}:`, error);
                toast.error(`Something Went Wrong with ${file.name}`);
            }
        });
    };
    const GetCustomerAttachment = (customerOrderId) => {
        var config = {
            method: 'get',
            url: 'CustomerOrder/GetCustomerAttachment',
            headers: {
                'Content-Type': 'application/json'
            },
            params: { customerOrderId }
        };

        axiosInstance(config)
            .then(function (response) {
                setUploadedFiles(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }
    const handleDelete = (attachmentId) => {
        var config = {
            method: 'post',
            url: "SupplierSalesOrder/DeleteAttachment/" + attachmentId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };
        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    GetCustomerAttachment(pId.OrderId);
                }
            })
            .catch(function (error) {
                toast.error(error.response.data);
            });
    }
    const renderFilePreview = (file) => {
        const fileExtension = file.name.split('.').pop().toLowerCase();

        switch (fileExtension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return (
                    <a href={`${file.path}`} target="_blank" rel="noopener noreferrer">
                        <img
                            src={`${file.path}`}
                            alt={file.name}
                            height="50"
                            width="100"
                            className="auth-logo-light"
                            style={{ marginRight: '10px', marginTop: '10px' }}
                        />
                    </a>
                );
            case 'pdf':
            case 'txt':
            case 'doc':
            case 'docx':
            case 'xls':
            case 'csv':
                return (
                    <a
                        href={`${file.path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="auth-logo-light"
                        style={{ marginRight: '10px', marginTop: '10px' }}
                    >
                        {file.name}
                    </a>
                );
            default:
                return <span>Unsupported file type</span>;
        }
    }

    const [editingCommercialInvoiceCostId, setEditingCommercialInvoiceCostId] = useState(0);
    const [deletingCommercialInvoiceCostId, setDeletingCommercialInvoiceCostId] = useState(0);
    const [showDeleteCommercialInvoiceCost, setShowDeleteCommercialInvoiceCost] = useState(false);
    const handleCloseDeleteCommercialInvoiceCost = () => setShowDeleteCommercialInvoiceCost(false);
    const handleShowDeleteCommercialInvoiceCost = () => setShowDeleteCommercialInvoiceCost(true);

    const [showAddCommercialInvoiceCost, setShowAddCommercialInvoiceCost] = useState(false);
    const handleCloseAddCommercialInvoiceCost = () => setShowAddCommercialInvoiceCost(false);
    const handleShowAddCommercialInvoiceCost = () => setShowAddCommercialInvoiceCost(true);
    const [commercialInvoiceCost, setCommercialInvoiceCost] = useState({
        customerCommercialInvoiceId: 0,
        amount: 0,
        shippingCostOptionId: 0,
        userId: localStorage.getItem("uTsReD"),
    });


    const [editingAdvancedChargesId, setEditingAdvancedChargesId] = useState(0);
    const [deletingAdvancedChargesId, setDeletingAdvancedChargesId] = useState(0);
    const [showDeleteAdvancedCharges, setShowDeleteAdvancedCharges] = useState(false);
    const handleCloseDeleteAdvancedCharges = () => setShowDeleteAdvancedCharges(false);
    const handleShowDeleteAdvancedCharges = () => setShowDeleteAdvancedCharges(true);

    const [showAddAdvancedCharges, setShowAddAdvancedCharges] = useState(false);
    const handleCloseAddAdvancedCharges = () => setShowAddAdvancedCharges(false);
    const handleShowAddAdvancedCharges = () => setShowAddAdvancedCharges(true);
    const [advancedCharges, setAdvancedCharges] = useState({
        customerOrderId: pId.OrderId,
        amount: 0,
        shippingCostOptionId: 0,
        userId: localStorage.getItem("uTsReD"),
    });

    const [shippingCostTypes, setShippingCostTypes] = useState([])
    const GetShippingCostTypes = () => {
        var config = {
            method: 'get',
            url: "ShippingCostType/GetShippingCostsOptions?companyId=" + localStorage.getItem("C0m8N!"),
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                setShippingCostTypes(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const IsValidCommercialInvoiceCost = () => {
        if (commercialInvoiceCost.shippingCostOptionId === 0 && commercialInvoiceCost.amount === 0.0) {
            toast.error("Enter all required fields");
            return false;
        }
        else if (commercialInvoiceCost.shippingCostOptionId === 0) {
            toast.error("Select the shipping cost invoice type.");
            return false;
        } else if (commercialInvoiceCost.amount <= 0.0) {
            toast.error("Enter the amount.");
            return false;
        }
        return true;
    }
    const IsValidAdvancedCharges = () => {
        if (advancedCharges.shippingCostOptionId === 0 && advancedCharges.amount === 0.0) {
            toast.error("Enter all required fields");
            return false;
        }
        else if (advancedCharges.shippingCostOptionId === 0) {
            toast.error("Select the shipping cost invoice type.");
            return false;
        } else if (advancedCharges.amount <= 0.0) {
            toast.error("Enter the amount.");
            return false;
        }
        return true;
    }

    const IsValidAdvancedPayment = () => {
        if (advancedPayment.amount <= 0) {
            toast.error("Please enter a valid amount");
            return false;
        }
        if (advancedPayment.bankId === 0) {
            toast.error("Please select a bank");
            return false;
        }
        if (advancedPayment.bankAccountId === 0) {
            toast.error("Please select a bank account");
            return false;
        }
        return true;
    };

    const AddAdvancedPayments = (e) => {
        e.preventDefault();
        
        if (!IsValidAdvancedPayment()) {
            return;
        }
        
        var config = {
            method: 'post',
            url: "CustomerAdvancedPayment/AddCustomerAdvancedPayment",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: advancedPayment
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.success(response.data.message);
                    setShowAddAdvancedPayment(false);
                    GetAdvancedPayments(pId.OrderId);
                    GetCustomerOrderTotal(pId.OrderId);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response?.data?.message || "Failed to add payment");
            });
    }

    const GetAdvancedPayments = (orderId) => {
        var config = {
            method: 'get',
            url: "CustomerAdvancedPayment/GetCustomerAdvancedPayments?customerOrderId=" + orderId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        return axiosInstance(config)
            .then(function (response) {
                setAdvancedPayments(response.data);
                GetAdvancedDiscounts(orderId);
                return response;
            })
            .catch(function (error) {
                console.log(error);
                throw error;
            });
    }

    // Edit payment function
    const EditAdvancedPayment = (e) => {
        e.preventDefault();
        
        // Prepare the data according to CustomerAdvancedPaymentModel
        const editData = {
            Amount: parseFloat(editingPayment.amount),
            Date: editingPayment.date,
            CustomerOrderId: editingPayment.customerOrderId,
            BankId: parseInt(editingPayment.bankId),
            BankAccountId: parseInt(editingPayment.bankAccountId),
            BankAmount: parseFloat(editingPayment.bankAmount),
            BankExchange: parseFloat(editingPayment.bankExchange),
            PaymentPercentage: parseFloat(editingPayment.paymentPercentage),
            UserId: parseInt(editingPayment.userId),
            CompanyId: parseInt(editingPayment.companyId),
            Notes: editingPayment.notes || "",
            CustomerName: editingPayment.customerName || "",
            CustomerAccountName: editingPayment.customerAccountName || "",
            Proforma: editingPayment.proforma || "",
            CustomerId: parseInt(editingPayment.customerId),
            CustomerAccountId: parseInt(editingPayment.customerAccountId)
        };
        
        var config = {
            method: 'post',
            url: `CustomerAdvancedPayment/EditCustomerAdvancedPayment?CustomerAdvancedPaymentId=${editingPayment.customerAdvancedPaymentId}`,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: editData
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.success("Payment updated successfully!");
                    setShowEditAdvancedPayment(false);
                    GetAdvancedPayments(pId.OrderId);
                    GetCustomerOrderTotal(pId.OrderId);
                    GetCustomerOrder(pId.OrderId);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response?.data?.message || "Failed to update payment");
            });
    }

    // Delete payment function
    const DeleteAdvancedPayment = (paymentId) => {
        if (window.confirm("Are you sure you want to delete this payment?")) {
            var config = {
                method: 'delete',
                url: `CustomerAdvancedPayment/DeleteCustomerAdvancedPayment?UserId=${localStorage.getItem("uTsReD")}&CompanyId=${localStorage.getItem("C0m8N!")}&AdvancedPaymentId=${paymentId}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                }
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        toast.success("Payment deleted successfully!");
                        GetAdvancedPayments(pId.OrderId);
                        GetCustomerOrderTotal(pId.OrderId);
                        GetCustomerOrder(pId.OrderId);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    toast.error(error.response?.data?.message || "Failed to delete payment");
                });
        }
    }

    // Percentage calculation functions for edit modal
    const reloadAmountFromPercentageEdit = (percentage) => {
        var originalPayment = orderTotal.remainingTotalAmount * percentage / 100.0;
        var x = originalPayment;
        var y = editingPayment.bankExchange;
        var z = x * y;
        setEditingPayment((prevState) => ({
            ...prevState,
            amount: originalPayment,
            bankAmount: z,
        }))
    }

    const reloadBankAmountEdit = (originalPayment) => {
        var percentage = originalPayment * 100.0 / orderTotal.remainingTotalAmount;
        var x = originalPayment;
        var y = editingPayment.bankExchange;
        var z = x * y;
        setEditingPayment((prevState) => ({
            ...prevState,
            bankAmount: z,
            paymentPercentage: percentage
        }))
    }

    const handleBankAmountEdit = (rate) => {
        var x = editingPayment.amount;
        var y = rate;
        var z = x * y;
        setEditingPayment((prevState) => ({ ...prevState, bankAmount: z }))
    }

    // Handle edit payment click
    const handleEditPayment = (payment) => {
        // Calculate percentage based on order total
        const percentage = orderTotal && orderTotal.totalAmount > 0 
            ? ((payment.amount / orderTotal.totalAmount) * 100).toFixed(2)
            : 0.0;

        setEditingPayment({
            customerAdvancedPaymentId: payment.customerAdvancedPaymentId,
            amount: payment.amount,
            paymentPercentage: parseFloat(percentage),
            date: payment.date.split("T")[0],
            notes: payment.notes || "",
            customerOrderId: pId.OrderId,
            bankId: payment.bankId,
            bankExchange: payment.bankExchange || 1,
            bankAmount: payment.bankAmount || 0,
            bankAccountId: payment.bankAccountId,
            proforma: "",
            customerId: pId.CustomerId,
            userId: localStorage.getItem("uTsReD"),
            companyId: localStorage.getItem("C0m8N!"),
            customerAccountId: pId.AccountId,
            customerName: "",
            customerAccountName: ""
        });
        
        // Load bank accounts for the selected bank
        if (payment.bankId) {
            GetBankAccounts(payment.bankId).then(() => {
                handleShowEditAdvancedPayment();
            });
        } else {
            handleShowEditAdvancedPayment();
        }
    }

    const GetAdvancedCharges = (orderId) => {
        var config = {
            method: 'get',
            url: "CustomerOrderAdvancedCharges/GetCustomerOrderAdvancedCharges?customerOrderId=" + orderId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        return axiosInstance(config)
            .then(function (response) {
                setOrderAdvancedCharges(response.data);
                return response;
            })
            .catch(function (error) {
                console.log(error);
                throw error;
            });
    }

    const AddAdvancedDiscount = (e) => {
        e.preventDefault();
        var config = {
            method: 'post',
            url: "CustomerAdvancedDiscount/AddCustomerAdvancedDiscount",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: advancedDiscount
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.success("Added Successfully")
                    setShowAdvancedDiscount(false)
                    GetAdvancedDiscounts(pId.OrderId);
                    GetCustomerOrderTotal(pId.OrderId);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error("Something Went Wrong")
            });
    }
    const GetAdvancedDiscounts = (orderId) => {
        var config = {
            method: 'get',
            url: "CustomerAdvancedDiscount/GetCustomerAdvancedDiscounts/" + orderId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        return axiosInstance(config)
            .then(function (response) {
                setAdvancedDiscounts(response.data);
                GetCommercialInvoices(orderId);
                GetAdvancedCharges(pId.OrderId);
                return response;
            })
            .catch(function (error) {
                console.log(error);
                // GetCommercialInvoices(orderId);
                GetAdvancedCharges(pId.OrderId);
                throw error;
            });
    }

    // Edit advanced discount function
    const EditAdvancedDiscount = (e) => {
        e.preventDefault();
        var config = {
            method: 'put',
            url: "CustomerAdvancedDiscount/EditCustomerAdvancedDiscount?AdvancedDiscountId=" + editingDiscount.advancedDiscountId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: editingDiscount
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.success("Discount updated successfully");
                    setShowEditAdvancedDiscount(false);
                    GetAdvancedDiscounts(pId.OrderId);
                    GetCustomerOrderTotal(pId.OrderId);
                    GetCustomerOrder(pId.OrderId);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response?.data?.message || "Failed to update discount");
            });
    }

    // Delete advanced discount function
    const DeleteAdvancedDiscount = (discountId) => {
        var config = {
            method: 'delete',
            url: "CustomerAdvancedDiscount/DeleteCustomerAdvancedDiscount?AdvancedDiscountId=" + discountId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.success("Discount deleted successfully");
                    GetAdvancedDiscounts(pId.OrderId);
                    GetCustomerOrderTotal(pId.OrderId);
                    GetCustomerOrder(pId.OrderId);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response?.data?.message || "Failed to delete discount");
            });
    }

    // Handle edit discount click
    const handleEditDiscount = (discount) => {
        setEditingDiscount({
            advancedDiscountId: discount.advancedDiscountId,
            advancedDiscount: discount.advancedDiscount,
            discountDate: discount.discountDate.split("T")[0],
            notes: discount.notes || "",
            orderId: discount.orderId,
            proforma: discount.proforma || "",
            userId: discount.userId,
            companyId: discount.companyId,
            customerAccountId: discount.customerAccountId,
            addToStatement: discount.addToStatement || false
        });
        setShowEditAdvancedDiscount(true);
    }

    const submitCommercialInvoiceCostForm = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (IsValidCommercialInvoiceCost()) {
            if (editingCommercialInvoiceCostId > 0) {
                var config = {
                    method: 'put',
                    url: "CustomerCommercialInvoice/EditCustomerCommercialInvoiceShippingCost",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    params: {
                        'customerCommercialInvoiceShippingCostId': editingCommercialInvoiceCostId
                    },
                    data: commercialInvoiceCost
                };

                axiosInstance(config)
                    .then(function (response) {
                        toast.success("Cost Updated Successfully")
                        handleCloseAddCommercialInvoiceCost();
                        GetCommercialInvoices(pId.OrderId);
                        GetCustomerOrder(pId.OrderId);
                        setSubmitDisabled(false);
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error(error.response.data);
                        setSubmitDisabled(false);
                    });
            } else {
                var config = {
                    method: 'post',
                    url: "CustomerCommercialInvoice/AddCustomerCommercialInvoiceShippingCost",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: commercialInvoiceCost
                };

                axiosInstance(config)
                    .then(function (response) {
                        toast.success("Cost Added Successfully")
                        handleCloseAddCommercialInvoiceCost();
                        // setShipmentShippingCosts(response.data);
                        GetCommercialInvoices(pId.OrderId);
                        setSubmitDisabled(false);
                        GetCustomerOrder(pId.OrderId);
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error(error.response.data)
                        setSubmitDisabled(false);
                    });
            }
        } else {
            setSubmitDisabled(false);
        }
    }

    const submitAdvancedChargesForm = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (IsValidAdvancedCharges()) {
            if (editingAdvancedChargesId > 0) {
                var config = {
                    method: 'put',
                    url: "CustomerOrderAdvancedCharges/EditCustomerOrderAdvancedCharges",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    params: {
                        'customerOrderAdvancedChargesId': editingAdvancedChargesId
                    },
                    data: advancedCharges
                };

                axiosInstance(config)
                    .then(function (response) {
                        toast.success("Charges Updated Successfully")
                        handleCloseAddAdvancedCharges();
                        setOrderAdvancedCharges(response.data);
                        GetAdvancedCharges(pId.OrderId);
                        GetCustomerOrderTotal(pId.OrderId);
                        GetCustomerOrder(pId.OrderId);
                        setSubmitDisabled(false);
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error(error.response.data);
                        setSubmitDisabled(false);
                    });
            } else {
                var config = {
                    method: 'post',
                    url: "CustomerOrderAdvancedCharges/AddCustomerAdvancedCharges",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: advancedCharges
                };

                axiosInstance(config)
                    .then(function (response) {
                        toast.success("Charges Added Successfully")
                        handleCloseAddAdvancedCharges();
                        setOrderAdvancedCharges(response.data);
                        GetAdvancedCharges(pId.OrderId);
                        GetCustomerOrderTotal(pId.OrderId);
                        GetCustomerOrder(pId.OrderId);
                        setSubmitDisabled(false);
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error(error.response.data)
                        setSubmitDisabled(false);
                    });
            }
        } else {
            setSubmitDisabled(false);
        }
    }

    const DeleteCommercialInvoiceCost = (costId) => {
        var config = {
            method: 'delete',
            url: "CustomerCommercialInvoice/DeleteCustomerCommercialInvoiceShippingCost?CustomerCommercialInvoiceShippingCostId=" + costId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                toast.success("Cost deleted successfully.");
                GetCommercialInvoices(pId.OrderId);
                handleCloseDeleteCommercialInvoiceCost();
                GetCustomerOrder(pId.OrderId);
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response.data.message);
            });
    }


    const DeleteAdvancedCharges = (chargesId) => {
        var config = {
            method: 'delete',
            url: "CustomerOrderAdvancedCharges/DeleteCustomerOrderAdvancedCharges?CustomerOrderAdvancedChargesId=" + chargesId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                toast.success("Charges deleted successfully.");
                setOrderAdvancedCharges(response.data);
                GetAdvancedCharges(pId.OrderId);
                GetCustomerOrderTotal(pId.OrderId);
                GetCustomerOrder(pId.OrderId);
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response?.data?.message || "Failed to delete charges");
            });
    }


    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="page-title-box">
                                <h4>Clients</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item"><Link to="/Accounting/Customer">Clients</Link></li>
                                    <li className="breadcrumb-item">
                                        <Link onClick={() => { navigate(-2) }}>{customerName}</Link></li>
                                    <li className="breadcrumb-item">
                                        <Link onClick={() => { navigate(-1) }}>{account.customerAccount1}</Link>
                                    </li>
                                    <li className="breadcrumb-item"><a href="#">#{order.invoiceNumber}</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <Row >
                        <Col sm={5} className="flex">
                            <Card>
                                <CardBody>
                                    <table cellPadding={10}>
                                        <tr>
                                            <td>
                                                <div role="alert">
                                                    <div className="row">
                                                        <div className="col-10">
                                                            {/* fas fa-info-circle */}
                                                            <h5 class="alert-heading font-18"><i class="fas fa-file-invoice" /> Order Details</h5>
                                                        </div>
                                                        <Col md={2} className="text-right">
                                                            {permissions.manageCustomerOrder === true && (
                                                                <div className="d-flex justify-content-end">
                                                                    <Button variant="outline-warning" size="sm" className="me-1"
                                                                        onClick={() => {

                                                                            // todo:
                                                                            GetPaymentTerms();

                                                                            setEditingOrder((prevState) => ({
                                                                                ...prevState,
                                                                                invoiceNumber: order.invoiceNumber,
                                                                                commission: order.commissionPerFCL,
                                                                                notes: order.notes,
                                                                                paymentTermsId: order.paymentTermsId,
                                                                                paymentTermsName: order.paymentTermsName,
                                                                                date: order.date.split('T')[0],
                                                                            }));

                                                                            handleShowEditCustomerOrder();
                                                                        }
                                                                        } ><FiEdit /></Button>
                                                                    <Button variant="outline-danger" size="sm" onClick={() => {
                                                                        handleShowDeleteCustomerOrder();
                                                                    }
                                                                    }><FiTrash2 /></Button>
                                                                </div>
                                                            )}
                                                        </Col>
                                                        <p>
                                                            Invoice Number: <b>{order.invoiceNumber != null && order.invoiceNumber.length > 0 ? '#' + order.invoiceNumber : <Skeleton width={100} />}</b>
                                                            <br />
                                                            Supplier Invoices: <b>{order.supplierInvoices != null && order.supplierInvoices.length > 0 ? '#' + order.supplierInvoices : <Skeleton width={100} />}</b>
                                                            <br />
                                                            Order Date: <b>{order.date != null && order.date.length > 0 ? order.date.split('T')[0] : <Skeleton width={100} />}</b>
                                                            <br />
                                                            Commission Per FCL: <b>{order.commissionPerFCL != null && order.commissionPerFCL != null ? currency.currencySuffix + " " + order.commissionPerFCL.toLocaleString() : currency.currencySuffix + " 0"}</b>
                                                            <br />
                                                            {/* Total Commission: <b>{order.totalCommission != null && order.totalCommission != null ? currency.currencySuffix + " " + order.totalCommission.toLocaleString() : currency.currencySuffix + " 0"}</b>
                                                            <br /> */}

                                                            Total: <b>{order.totalPrice != null && order.totalPrice != null ? currency.currencySuffix + " " + order.totalPrice.toLocaleString() : currency.currencySuffix + " 0"}</b>
                                                            <br />

                                                            Remaining: <b>{orderTotal.remainingTotalAmount != null && orderTotal.remainingTotalAmount != null ? currency.currencySuffix + " " + orderTotal.remainingTotalAmount.toLocaleString() : currency.currencySuffix + " 0"}</b>
                                                            <br />
                                                            {/*Other Charges: <b>{orderTotal != null && orderTotal.otherCharges != null ? currency.currencySuffix + " " + orderTotal.otherCharges.toLocaleString() : <Skeleton width={100} />}</b>
                                                            <br />
                                                            Total: <b>{orderTotal != null && orderTotal.totalAmount != null ? currency.currencySuffix + " " + orderTotal.totalAmount.toLocaleString() : <Skeleton width={100} />}</b> */}
                                                        </p>
                                                        <table cellPadding={10}>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <div role="alert">
                                                                            <div className="row" style={{ display: 'flex', height: '100%' }}>
                                                                                <div className="col-6" style={{ flex: 1, display: 'flex' }}>
                                                                                    <div className="alert alert-warning fade show mb-0" role="alert" style={{ flex: 1 }}>
                                                                                        <h6 className="alert-heading font-18"><i class="mdi mdi-cash-lock" /> Payment Terms</h6>
                                                                                        <span className="text-secondary">{order.paymentTermsName != null && order.paymentTermsName.length > 0 ? order.paymentTermsName : "-"}</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-6" style={{ flex: 1, display: 'flex' }}>
                                                                                    <div className="alert alert-warning fade show mb-0" role="alert" style={{ flex: 1 }}>
                                                                                        <h6 className="alert-heading font-18"><i className="fas fa-pencil-alt" /> Notes</h6>
                                                                                        <span className="text-secondary">{order.notes}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <Tabs defaultActiveKey="products" className="mt-3 ms-2">
                                                            <Tab
                                                                eventKey="products"
                                                                title={
                                                                    <span>
                                                                        Products{' '}
                                                                        {/* <Badge className="rounded-pill bg-primary badge">{c.products?.length || 0}</Badge> */}
                                                                        {
                                                                            order.productsPrice > 0 &&
                                                                            <Badge className="rounded-pill bg-primary badge">{order.productsPrice.toLocaleString() || 0}</Badge>
                                                                        }
                                                                        {
                                                                            //orderTotal.orderProducts != null && orderTotal.orderProducts > 0 &&
                                                                            //<Badge className="rounded-pill bg-primary badge">{orderTotal.orderProducts.toLocaleString() || 0}</Badge>

                                                                        }
                                                                    </span>
                                                                }>
                                                                <div className="mt-3">
                                                                    {order.products != null && order.products.length > 0 && order.products.map((p, index) => {
                                                                        return (
                                                                            <Alert key={index} variant="primary" className="fade show">
                                                                                <Row>
                                                                                    <Col md={10}>
                                                                                        <h6 className="alert-heading font-18">
                                                                                            <b>{p.fcl} FCL ({p.productQuantity.toLocaleString()} {p.productUnitName}) {p.productName}, {p.productTypeName}, {p.productSizeName}</b>
                                                                                        </h6>
                                                                                        <span className="text-secondary">Unit Price: <b>{currency.currencySuffix} {p.unitPrice.toLocaleString()}</b></span><br />
                                                                                        <span className="text-secondary">Total Price: <b>{currency.currencySuffix} {(p.productQuantity * p.unitPrice).toLocaleString()}</b></span><br />
                                                                                    </Col>
                                                                                    <Col md={2} className="text-right">
                                                                                        {permissions.manageCustomerOrder === true && (
                                                                                            <div className="d-flex justify-content-end">
                                                                                                <Button variant="warning" size="sm" className="me-1" onClick={(e) => {
                                                                                                    setEditingProductId(p.customerOrderProductId);

                                                                                                    //GetSupplierOrderProductBySupplierId(p.supplierId);
                                                                                                    handleSupplierChange(p.supplierId);

                                                                                                    setOrderProduct((prevState) => ({
                                                                                                        ...prevState,
                                                                                                        customerOrderId: pId.OrderId,
                                                                                                        customerOrderProductId: p.customerOrderProductId,
                                                                                                        productQuantity: p.productQuantity,
                                                                                                        productUnitName: p.productUnitName,
                                                                                                        fcl: p.fcl,
                                                                                                        oldFcl: p.fcl,
                                                                                                        unitPrice: p.unitPrice,
                                                                                                        supplierId: p.supplierId,
                                                                                                        supplierName: suppliers && suppliers.length > 0
                                                                                                            ? (suppliers.find((s) => s.supplierId === p.supplierId)?.supplierName || "")
                                                                                                            : "",
                                                                                                        pendingFcl: p.pendingFcl,
                                                                                                        supplierOrderProductId: p.supplierOrderProductId,
                                                                                                        productDescription: p.productName + ", " + p.productTypeName + ", " + p.productSizeName,
                                                                                                        description: " FCL, " + p.productName + ", " + p.productTypeName + ", " + p.productSizeName,
                                                                                                        unit: p.productUnitName,
                                                                                                        // description: row.product.productName + ", " + row.type.productTypeName + ", " + row.size.productSizeName,
                                                                                                        // unit: row.customerOrderProduct.unit,
                                                                                                    }));
                                                                                                    handleShowAddOrderProduct();
                                                                                                }}><FiEdit /></Button>
                                                                                                <Button variant="danger" size="sm" onClick={() => {
                                                                                                    setDeletingCustomerOrderProductId(p.customerOrderProductId);
                                                                                                    handleShowDeleteCustomerOrderProduct();
                                                                                                }}><FiTrash2 /></Button>
                                                                                            </div>
                                                                                        )}
                                                                                    </Col>
                                                                                </Row>
                                                                            </Alert>
                                                                        );
                                                                    })}
                                                                    {permissions.manageCustomerOrder === true && (
                                                                        <Button variant="outline-primary" className="w-100 mt-3"
                                                                            onClick={() => {
                                                                                setEditingProductId(0);
                                                                                setOrderProduct({
                                                                                    supplierOrderProductId: 0,
                                                                                    customerOrderId: order.customerOrderId,
                                                                                    productQuantity: 0,
                                                                                    fcl: 0,
                                                                                    unitPrice: 0,
                                                                                    supplierId: 0,
                                                                                    userId: localStorage.getItem("uTsReD"),
                                                                                    proforma: "",
                                                                                    description: "",
                                                                                    commissionPerFCL: 0.0,
                                                                                    unit: ""
                                                                                });
                                                                                handleShowAddOrderProduct();
                                                                            }}>
                                                                            <b><FiPlus /> Add New Product</b>
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </Tab>
                                                            <Tab
                                                                eventKey="payments"
                                                                title={
                                                                    <span>
                                                                        Advanced Payments{' '}
                                                                        {/* <Badge className="rounded-pill bg-primary badge">{advancedPayments?.length || 0}</Badge> */}
                                                                        {
                                                                            orderTotal.orderAdvancedPayments != null && orderTotal.orderAdvancedPayments > 0 &&
                                                                            <Badge className="rounded-pill bg-primary badge">{orderTotal.orderAdvancedPayments.toLocaleString() || 0}</Badge>
                                                                        }
                                                                    </span>
                                                                }
                                                            >
                                                                <div className="mt-3">
                                                                    {advancedPayments != null && advancedPayments.length > 0 && advancedPayments.map((p, index) => {
                                                                        return (
                                                                            <Alert key={index} variant="primary" className="fade show">
                                                                                <Row>
                                                                                    <Col md={8}>
                                                                                        <h6 className="alert-heading font-18">
                                                                                            Amount: <b>{currency.currencySuffix} {p.amount.toLocaleString()}</b>
                                                                                        </h6>
                                                                                        <span className="text-secondary"><i className="mdi mdi-bank" /> {p.bankName} - {p.bankAccountName}</span><br />
                                                                                        {p.notes && <span className="text-secondary"><i className="fas fa-pencil-alt" /> {p.notes}</span>}
                                                                                    </Col>
                                                                                    <Col md={4} className="text-right">
                                                                                        <div className="d-flex justify-content-end align-items-center">
                                                                                            <h6 className="alert-heading font-14 me-3"><b>{p.date.split("T")[0]}</b></h6>
                                                                                            <div className="d-flex gap-2">
                                                                                                <button
                                                                                                    className="btn btn-sm btn-outline-primary"
                                                                                                    onClick={() => handleEditPayment(p)}
                                                                                                    title="Edit Payment"
                                                                                                >
                                                                                                    <FiEdit />
                                                                                                </button>
                                                                                                <button
                                                                                                    className="btn btn-sm btn-outline-danger"
                                                                                                    onClick={() => DeleteAdvancedPayment(p.customerAdvancedPaymentId)}
                                                                                                    title="Delete Payment"
                                                                                                >
                                                                                                    <FiTrash2 />
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Alert>
                                                                        );
                                                                    })}
                                                                    <Button variant="outline-primary" className="w-100 mt-3" onClick={handleShowAddAdvancedPayment}>
                                                                        <b><FiPlus /> Add New Payment</b>
                                                                    </Button>
                                                                </div>
                                                            </Tab>

                                                            <Tab
                                                                eventKey="discounts"
                                                                title={
                                                                    <span>
                                                                       Advanced Discounts{' '}
                                                                        {/* <Badge className="rounded-pill bg-primary badge">{advancedDiscounts?.length || 0}</Badge> */}
                                                                        {
                                                                            orderTotal.orderAdvancedDiscounts != null && orderTotal.orderAdvancedDiscounts > 0 &&
                                                                            <Badge className="rounded-pill bg-primary badge">{orderTotal.orderAdvancedDiscounts.toLocaleString() || 0}</Badge>
                                                                        }
                                                                    </span>
                                                                }
                                                            >
                                                                <div className="mt-3">
                                                                    {advancedDiscounts != null && advancedDiscounts.length > 0 && advancedDiscounts.map((d, index) => {
                                                                        return (
                                                                            <Alert key={index} variant="primary" className="fade show">
                                                                                <Row>
                                                                                    <Col md={7}>
                                                                                        <h6 className="alert-heading font-18">
                                                                                            Amount: <b>{currency.currencySuffix} {d.advancedDiscount.toLocaleString()}</b>
                                                                                        </h6>
                                                                                        {d.notes && <span className="text-secondary"><i className="fas fa-pencil-alt" /> {d.notes}</span>}
                                                                                    </Col>
                                                                                    <Col md={3} className="text-right">
                                                                                        <div className="d-flex justify-content-end">
                                                                                            <h6 className="alert-heading font-14"><b>{d.discountDate.split("T")[0]}</b></h6>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col md={2} className="text-right">
                                                                                        <div className="d-flex justify-content-end gap-1">
                                                                                            <Button
                                                                                                variant="outline-primary"
                                                                                                size="sm"
                                                                                                onClick={() => handleEditDiscount(d)}
                                                                                                title="Edit Discount"
                                                                                            >
                                                                                                <FiEdit />
                                                                                            </Button>
                                                                                            <Button
                                                                                                variant="outline-danger"
                                                                                                size="sm"
                                                                                                onClick={() => DeleteAdvancedDiscount(d.advancedDiscountId)}
                                                                                                title="Delete Discount"
                                                                                            >
                                                                                                <FiTrash2 />
                                                                                            </Button>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Alert>
                                                                        );
                                                                    })}
                                                                    <Button variant="outline-primary" className="w-100 mt-3" onClick={handleShowAdvancedDiscount}>
                                                                        <b><FiPlus /> Add New Discount</b>
                                                                    </Button>
                                                                </div>
                                                            </Tab>
                                                            <Tab
                                                                eventKey="advcharges"
                                                                title={
                                                                    <span>
                                                                        Charges{' '}
                                                                        {
                                                                            (orderAdvancedCharges != null && orderAdvancedCharges.length > 0 && orderAdvancedCharges?.reduce((sum, p) => sum + p.amount, 0) > 0) && (
                                                                                <Badge className="rounded-pill bg-primary badge">
                                                                                    {orderAdvancedCharges.reduce((sum, p) => sum + p.amount, 0).toLocaleString()}
                                                                                </Badge>
                                                                            )
                                                                        }
                                                                    </span>
                                                                }
                                                            >
                                                                <div className="mt-3">
                                                                    {orderAdvancedCharges != null && orderAdvancedCharges.length > 0 && orderAdvancedCharges.map((p, index) => {
                                                                        return (
                                                                            <Alert key={index} variant="primary" className="fade show">
                                                                                <Row>
                                                                                    <Col md={10}>
                                                                                        <h6 className="alert-heading font-18">
                                                                                            {p.name}: <b>{currency.currencySuffix} {p.amount.toLocaleString()}</b>
                                                                                        </h6>
                                                                                    </Col>
                                                                                    <Col md={2} className="text-right">
                                                                                        {permissions.manageCustomerOrder === true && (
                                                                                            <div className="d-flex justify-content-end">
                                                                                                <Button variant="warning" size="sm" className="me-1" onClick={(e) => {
                                                                                                    setEditingAdvancedChargesId(p.customerOrderAdvancedChargesId)

                                                                                                    setAdvancedCharges((prevState) => ({
                                                                                                        ...prevState,
                                                                                                        customerOrderId: pId.OrderId,
                                                                                                        amount: p.amount,
                                                                                                        shippingCostOptionId: p.shippingCostsOptionId,
                                                                                                        shippingCostOptionName: p.name
                                                                                                    }));

                                                                                                    handleShowAddAdvancedCharges();
                                                                                                }}><FiEdit /></Button>
                                                                                                <Button variant="danger" size="sm" onClick={() => {
                                                                                                    DeleteAdvancedCharges(p.customerOrderAdvancedChargesId);
                                                                                                }}><FiTrash2 /></Button>
                                                                                            </div>
                                                                                        )}
                                                                                    </Col>
                                                                                </Row>
                                                                            </Alert>
                                                                        );
                                                                    })}
                                                                    {permissions.manageCustomerOrder === true && (
                                                                        <Button variant="outline-danger" className="w-100" onClick={() => {
                                                                            setEditingAdvancedChargesId(0)
                                                                            setCommercialInvoiceCost((prevState) => ({
                                                                                ...prevState,
                                                                                customerOrderId: pId.OrderId,
                                                                                amount: 0,
                                                                                shippingCostOptionId: 0,
                                                                                shippingCostOptionName: ""
                                                                            }));
                                                                            handleShowAddAdvancedCharges();
                                                                        }}>
                                                                            <b><FiPlus /> Add New Charge</b>
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </Tab>
                                                        </Tabs>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={7} className="flex">
                            <Card>
                                <CardBody>
                                    <table cellPadding={10}>
                                        <tr>
                                            <td>
                                                <div role="alert">
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <h5 class="alert-heading font-18"><i class="fas fa-file-alt" /> Commercial Invoices</h5>
                                                        </div>
                                                        <div className="mt-3">
                                                            {commercialInvoices != null && commercialInvoices.length > 0 && commercialInvoices.map((c, index) => {
                                                                return (
                                                                    <Alert key={index} style={{
                                                                        borderWidth: 3,
                                                                        backgroundColor: '#FAFAFA',
                                                                        borderColor: c.profit < 0 ? '#f64658' : '#ebfbf0',
                                                                      }} className="fade show">
                                                                        <Row>
                                                                        <Col md={10}>
                                                                        <p className="text-secondary">
                                                                                    Invoice Number: <b>{c.invoiceNumber != null && c.invoiceNumber.length > 0 ? '#' + c.invoiceNumber : <Skeleton width={100} />}</b>
                                                                                    <br />
                                                                                    Invoice Date: <b>{c.date != null && c.date.length > 0 ? c.date.split('T')[0] : <Skeleton width={100} />}</b>
                                                                                    <br />

                                                                                    </p>
                                                                                    </Col>
                                                                                    <Col md={2} className="text-right">
                                                                                {permissions.manageCustomerOrder === true && (
                                                                                    <div className="d-flex justify-content-end">
                                                                                        <Button variant="outline-warning" size="sm" className="me-1"
                                                                                            onClick={() => {
                                                                                                setEditingCommercialInvoiceId(c.customerCommercialInvoiceId);
                                                                                                setEditingCommercialInvoice((prevState) => ({
                                                                                                    ...prevState,
                                                                                                    customerCommercialInvoice: c.invoiceNumber,
                                                                                                    customerCommercialInvoiceDate: c.date.split('T')[0],
                                                                                                    notes: c.notes,
                                                                                                }));

                                                                                                
                                                                                                handleShowEditCommercialInvoice();
                                                                                            }
                                                                                            } ><FiEdit /></Button>
                                                                                        <Button variant="outline-danger" size="sm" onClick={() => {
                                                                                            // setDeletingCommercialId(c.commercialInvoiceId);
                                                                                            // handleShowDeleteInvoice();
                                                                                            setDeletingCommercialInvoiceId(c.customerCommercialInvoiceId);
                                                                                            setDeletingCommercialInvoice(c.invoiceNumber);
                                                                                            setShowDeleteCommercialInvoice(true);
                                                                                        }
                                                                                        }><FiTrash2 /></Button>
                                                                                    </div>
                                                                                )}
                                                                                <div className="d-flex justify-content-end mt-2">
                                                                                    
                                                                                                <span style={{
                                                                                                    color: '#8e3241',
                                                                                                    backgroundColor: '#fbdde2',
                                                                                                    borderColor: '#f9cbd3',
                                                                                                    borderRadius: 5,
                                                                                                    paddingLeft: 5,
                                                                                                    paddingRight: 5
                                                                                                }}>
                                                                                                   <b>{currency.currencySuffix} {c.invoiceTotals.totalAmount.toLocaleString()}</b>
                                                                                                </span>

                                                                                </div>
                                                                                {/* <div className="d-flex justify-content-end mt-2">
                                                                                    {(c.tracking != null && c.tracking.statusId > 0) &&
                                                                                        <>
                                                                                            {
                                                                                                c.tracking.statusId < 50 ?
                                                                                                    <span style={{ ...trackingStatusStyles[c.tracking.statusId], borderRadius: 5, padding: '0 5px' }}><b>{c.tracking.status}</b></span>
                                                                                                    :
                                                                                                    <>
                                                                                                        {
                                                                                                            c.tracking.statusId === 50 &&
                                                                                                            <span style={{ ...trackingStatusStyles[c.tracking.statusId], borderRadius: 5, padding: '0 5px' }}><b>{c.tracking.status}</b></span>
                                                                                                        }
                                                                                                    </>
                                                                                            }
                                                                                        </>
                                                                                    }
                                                                                </div> */}
                                                                            </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                    <Col md={12}>
    <Table bordered size="sm">
        <tbody>
            {/* <tr>
                <td>Invoice Number</td>
                <td>
                    <b>{c.invoiceNumber != null && c.invoiceNumber.length > 0 ? '#' + c.invoiceNumber : <Skeleton width={100} />}</b>
                </td>
            </tr> */}
            <tr>
                <td>Supplier Invoice Number</td>
                <td><b>{'#' + c.supplierInvoiceNumber}</b></td>
            </tr>
            {/* <tr>
                <td>Invoice Date</td>
                <td>
                    <b>{c.date != null && c.date.length > 0 ? c.date.split('T')[0] : <Skeleton width={100} />}</b>
                </td>
            </tr> */}
          
            
            {c.tracking != null && c.tracking.statusId > 0 && c.tracking.statusId <= 50 && (
                <>
                    <tr>
                        <td>Bill of Lading</td>
                        <td><b>{c.tracking.shippingLine} - {c.tracking.blReferenceNo}</b></td>
                    </tr>
                    <tr>
                        <td>Tracking Status</td>
                        <td>
                            {/* <b>{c.tracking.arrivalDate}</b> */}
                                {(c.tracking != null && c.tracking.statusId > 0) &&
                                    <>
                                        {
                                            c.tracking.statusId < 50 ?
                                                <span style={{ ...trackingStatusStyles[c.tracking.statusId], borderRadius: 5, padding: '0 5px' }}><b>{c.tracking.status} - {c.tracking.arrivalDate}</b></span>
                                                :
                                                <>
                                                    {
                                                        c.tracking.statusId === 50 &&
                                                        <span style={{ ...trackingStatusStyles[c.tracking.statusId], borderRadius: 5, padding: '0 5px' }}><b>{c.tracking.status} - {c.tracking.arrivalDate}</b></span>
                                                    }
                                                </>
                                        }
                                    </>
                                }
                        </td>
                    </tr>
                </>
            )}
            {/* {c.tracking != null && c.tracking.statusId === 50 && c.tracking.dischargeDate != null && (
                <>
                    <tr>
                        <td>Discharged on</td>
                        <td><b>{c.tracking.dischargeDate}</b></td>
                    </tr>
                    <tr>
                        <td>BL</td>
                        <td><b>{c.tracking.blReferenceNo}</b></td>
                    </tr>
                </>
            )} */}
            {c.invoiceTotals.proformaCharges != null && c.invoiceTotals.proformaCharges > 0 && (
                <tr>
                    <td>Charges From Proforma</td>
                    <td><b>{currency.currencySuffix} {c.invoiceTotals.proformaCharges.toLocaleString()}</b></td>
                </tr>
            )}
            {c.invoiceTotals.commission != null && c.invoiceTotals.commission > 0 && (
                <tr>
                    <td>Commission</td>
                    <td><b>{currency.currencySuffix} {c.invoiceTotals.commission.toLocaleString()}</b></td>
                </tr>
            )}
            <tr>
                <td>Invoice Total</td>
                <td><b>{currency.currencySuffix} {c.invoiceTotals.totalAmount.toLocaleString()}</b></td>
            </tr>
            {c.invoiceTotals.advancedPayment != null && c.invoiceTotals.advancedPayment > 0 && (
             <tr>
                <td>Advance Payment</td>
                <td><b>{currency.currencySuffix} {c.invoiceTotals.advancedPayment.toLocaleString()}</b></td>
            </tr>
            )}
            {c.invoiceTotals.advancedDiscount != null && c.invoiceTotals.advancedDiscount > 0 && (
                <tr>
                    <td>Advance Discount</td>
                    <td><b>{currency.currencySuffix} {c.invoiceTotals.advancedDiscount.toLocaleString()}</b></td>
                </tr>
            )}
              {c.profit != null && (
                <tr>
                    <td>{c.profit < 0 ? 'Loss' : 'Profit'}</td>
                    <td style={{ color: c.profit < 0 ? 'red' : 'inherit' }}>
                        <b>{currency.currencySuffix} {Math.abs(c.profit).toLocaleString()}</b>
                    </td>
                </tr>
            )}
            <tr>
                <td>Remaining To Pay</td>
                <td><b>{currency.currencySuffix} {c.invoiceTotals.remainingTotal.toLocaleString()}</b></td>
            </tr>
            {c.notes != null && c.notes.length > 0 && (
                <tr>
                    <td>Notes</td>
                    <td>{c.notes}</td>
                </tr>
            )}
        </tbody>
    </Table>
</Col>

                                                                            {/* <Col md={2} className="text-right">
                                                                                {permissions.manageCustomerOrder === true && (
                                                                                    <div className="d-flex justify-content-end">
                                                                                        <Button variant="outline-warning" size="sm" className="me-1"
                                                                                            onClick={() => {
                                                                                                setEditingCommercialInvoiceId(c.customerCommercialInvoiceId);
                                                                                                setEditingCommercialInvoice((prevState) => ({
                                                                                                    ...prevState,
                                                                                                    customerCommercialInvoice: c.invoiceNumber,
                                                                                                    customerCommercialInvoiceDate: c.date.split('T')[0],
                                                                                                    notes: c.notes,
                                                                                                }));

                                                                                                
                                                                                                handleShowEditCommercialInvoice();
                                                                                            }
                                                                                            } ><FiEdit /></Button>
                                                                                        <Button variant="outline-danger" size="sm" onClick={() => {
                                                                                            // setDeletingCommercialId(c.commercialInvoiceId);
                                                                                            // handleShowDeleteInvoice();
                                                                                            setDeletingCommercialInvoiceId(c.customerCommercialInvoiceId);
                                                                                            setDeletingCommercialInvoice(c.invoiceNumber);
                                                                                            setShowDeleteCommercialInvoice(true);
                                                                                        }
                                                                                        }><FiTrash2 /></Button>
                                                                                    </div>
                                                                                )}
                                                                                <div className="d-flex justify-content-end mt-2">
                                                                                    {
                                                                                        c.profit !== null && <>
                                                                                            {c.profit < 0 ? (
                                                                                                <span style={{
                                                                                                    color: '#8e3241',
                                                                                                    backgroundColor: '#fbdde2',
                                                                                                    borderColor: '#f9cbd3',
                                                                                                    borderRadius: 5,
                                                                                                    paddingLeft: 5,
                                                                                                    paddingRight: 5
                                                                                                }}>
                                                                                                   Loss: <b>{currency.currencySuffix} {c.profit?.toLocaleString()}</b>
                                                                                                </span>
                                                                                            ) : (
                                                                                                <span style={{
                                                                                                    color: "green",
                                                                                                    backgroundColor: '#ebfbf0',
                                                                                                    borderColor: '#green',
                                                                                                    borderRadius: 5,
                                                                                                    paddingLeft: 5,
                                                                                                    paddingRight: 5
                                                                                                }}>
                                                                                                    Profit: <b>{currency.currencySuffix} {c.profit?.toLocaleString()}</b>
                                                                                                </span>
                                                                                            )}
                                                                                            <br />
                                                                                        </>

                                                                                    }



                                                                                </div>
                                                                                <div className="d-flex justify-content-end mt-2">
                                                                                    {(c.tracking != null && c.tracking.statusId > 0) &&
                                                                                        <>
                                                                                            {
                                                                                                c.tracking.statusId < 50 ?
                                                                                                    <span style={{ ...trackingStatusStyles[c.tracking.statusId], borderRadius: 5, padding: '0 5px' }}><b>{c.tracking.status}</b></span>
                                                                                                    :
                                                                                                    <>
                                                                                                        {
                                                                                                            c.tracking.statusId === 50 &&
                                                                                                            <span style={{ ...trackingStatusStyles[c.tracking.statusId], borderRadius: 5, padding: '0 5px' }}><b>{c.tracking.status}</b></span>
                                                                                                        }
                                                                                                    </>
                                                                                            }
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                            </Col> */}
                                                                        </Row>
                                                                        <Row>
                                                                            <Tabs defaultActiveKey="products" className="ms-2">
                                                                                <Tab
                                                                                    eventKey="products"
                                                                                    title={
                                                                                        <span>
                                                                                            Products{' '}
                                                                                            {/* <Badge className="rounded-pill bg-primary badge">{c.products?.length || 0}</Badge> */}
                                                                                            {
                                                                                                c.invoiceTotals.productsTotal > 0 &&
                                                                                                <Badge className="rounded-pill bg-primary badge">{c.invoiceTotals.productsTotal.toLocaleString() || 0}</Badge>
                                                                                            }
                                                                                        </span>
                                                                                    }>
                                                                                    <div className="mt-3">
                                                                                        {c.products != null && c.products.length > 0 && c.products.map((p, index) => {
                                                                                            return (
                                                                                                <Alert key={index} variant="primary" className="fade show">
                                                                                                    <Row>
                                                                                                        <Col md={9}>
                                                                                                            <h6 className="alert-heading font-18">
                                                                                                                <b>{p.fcl} FCL ({p.productQuantity.toLocaleString()} {p.productUnitName}) {p.productName}, {p.productTypeName}, {p.productSizeName}</b>
                                                                                                            </h6>
                                                                                                            {/* <span className="text-secondary">Unit Price: <b>{currency.currencySuffix} {p.unitPrice.toLocaleString()}</b></span><br />
                                                                                                            <span className="text-secondary">Total Price: <b>{currency.currencySuffix} {(p.productQuantity * p.unitPrice).toLocaleString()}</b></span><br /> */}
                                                                                                        </Col>
                                                                                                        <Col md={3} className="text-right">
                                                                                                            <div className="d-flex justify-content-end mt-2">
                                                                                                                <span style={{ color: '#8e3241', backgroundColor: '#fbdde2', borderColor: '#f9cbd3', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{currency.currencySuffix} {(p.productQuantity * p.unitPrice).toLocaleString()}</b></span>
                                                                                                            </div>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Alert>
                                                                                            );
                                                                                        })}
                                                                                        {/* <Button variant="outline-primary" className="w-100" onClick={()=> {
                                                                                            //  setCommercialProduct((prevState) => ({
                                                                                            //     ...prevState,
                                                                                            //     commercialInvoiceId: c.commercialInvoiceId,
                                                                                            //     proforma: order.invoiceNumber,
                                                                                            //     commercialInvoice: c.invoiceNumber
                                                                                            // }));
                                                                                            // handleShowAddCommercialProduct();
                                                                                        }}>
                                                                                            <b><FiPlus /> Add New Product</b>
                                                                                        </Button> */}
                                                                                    </div>
                                                                                </Tab>
                                                                                {/* <Tab
                                                                                    eventKey="payments"
                                                                                    title={
                                                                                        <span>
                                                                                            Payments{' '}
                                                                                            {
                                                                                                c.invoiceTotals?.productTotalPayment > 0 &&
                                                                                                <Badge className="rounded-pill bg-primary badge">{c.invoiceTotals?.productTotalPayment.toLocaleString() || 0}</Badge>
                                                                                            }
                                                                                        </span>
                                                                                    }
                                                                                >
                                                                                    <div className="mt-3">
                                                                                        {c.payments != null && c.payments.length > 0 && c.payments.map((p, index) => {
                                                                                            return (
                                                                                                <Alert key={index} variant="primary" className="fade show">
                                                                                                    <Row>
                                                                                                        <Col md={9}>
                                                                                                            <h6 className="alert-heading font-18">
                                                                                                                Amount: <b>{currency.currencySuffix} {p.paymentValue.toLocaleString()}</b>
                                                                                                            </h6>
                                                                                                            <span className="text-secondary"><i className="mdi mdi-bank" /> {p.bankName}</span><br />
                                                                                                            {p.notes && <span className="text-secondary"><i className="fas fa-pencil-alt" /> {p.notes}</span>}
                                                                                                        </Col>
                                                                                                        <Col md={3} className="text-right">
                                                                                                            <div className="d-flex justify-content-end">
                                                                                                                <h6 className="alert-heading font-14"><b>{p.invoiceDate.split("T")[0]}</b></h6>
                                                                                                            </div>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Alert>
                                                                                            );
                                                                                        })}
                                                                                        {permissions.manageCustomerOrder === true && (
                                                                                            <Button variant="outline-primary" className="w-100" onClick={() => {
                                                                                                setCommercialInvoicePayment((prevState) => ({
                                                                                                    ...prevState,
                                                                                                    commercialInvoiceId: c.commercialInvoiceId,
                                                                                                    commercialInvoiceNumber: c.invoiceNumber,
                                                                                                    invoiceNumber: order.invoiceNumber,
                                                                                                    remainingTotal: c.invoiceTotals.remainingTotal,
                                                                                                    customerName: customerName,
                                                                                                    customerOrderId: order.customerOrderId,
                                                                                                    customerAccountName: account.customerAccount1,
                                                                                                }));
                                                                                                handleShowAddCommercialInvoicePayment();
                                                                                            }}>
                                                                                                <b><FiPlus /> Add New Payment</b>
                                                                                            </Button>
                                                                                        )}
                                                                                    </div>
                                                                                </Tab>

                                                                                <Tab
                                                                                    eventKey="discounts"
                                                                                    title={
                                                                                        <span>
                                                                                            Discounts{' '}
                                                                                            {
                                                                                                c.invoiceTotals?.productTotalDiscount > 0 &&
                                                                                                <Badge className="rounded-pill bg-primary badge">{c.invoiceTotals?.productTotalDiscount.toLocaleString() || 0}</Badge>
                                                                                            }
                                                                                        </span>
                                                                                    }
                                                                                >
                                                                                    <div className="mt-3">
                                                                                        {c.discounts != null && c.discounts.length > 0 && c.discounts.map((d, index) => {
                                                                                            return (
                                                                                                <Alert key={index} variant="primary" className="fade show">
                                                                                                    <Row>
                                                                                                        <Col md={9}>
                                                                                                            <h6 className="alert-heading font-18">
                                                                                                                Amount: <b>{currency.currencySuffix} {d.commercialInvoiceDiscount.toLocaleString()}</b>
                                                                                                            </h6>
                                                                                                            {d.notes && <span className="text-secondary"><i className="fas fa-pencil-alt" /> {d.notes}</span>}
                                                                                                        </Col>
                                                                                                        <Col md={3} className="text-right">
                                                                                                            <div className="d-flex justify-content-end">
                                                                                                                <h6 className="alert-heading font-14"><b>{d.discountDate.split("T")[0]}</b></h6>
                                                                                                            </div>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Alert>
                                                                                            );
                                                                                        })}
                                                                                        {permissions.manageCustomerOrder === true && (
                                                                                            <Button variant="outline-primary" className="w-100" onClick={() => {
                                                                                                setCommercialDiscount((prevState) => ({
                                                                                                    ...prevState,
                                                                                                    commercialInvoiceNumber: c.invoiceNumber,
                                                                                                    remainingTotal: c.invoiceTotals.remainingTotal,
                                                                                                    commercialInvoiceId: c.commercialInvoiceId,
                                                                                                    commercialInvoiceDiscount: 0,
                                                                                                    discountDate: formatDate(new Date()),
                                                                                                    notes: "",
                                                                                                    commercialInvoice: c.invoiceNumber,
                                                                                                    proforma: order.invoiceNumber,
                                                                                                    userId: localStorage.getItem("uTsReD"),
                                                                                                    addToStatement: false
                                                                                                }));
                                                                                                handleShowAddCommercialDiscount();
                                                                                            }}>
                                                                                                <b><FiPlus /> Add New Discount</b>
                                                                                            </Button>
                                                                                        )}
                                                                                    </div>
                                                                                </Tab> */}
                                                                                <Tab
                                                                                    eventKey="charges"
                                                                                    title={
                                                                                        <span>
                                                                                            Charges{' '}
                                                                                            {
                                                                                                (c.otherCharges?.reduce((sum, p) => sum + p.amount, 0) > 0) && (
                                                                                                    <Badge className="rounded-pill bg-primary badge">
                                                                                                        {c.otherCharges.reduce((sum, p) => sum + p.amount, 0).toLocaleString()}
                                                                                                    </Badge>
                                                                                                )
                                                                                            }
                                                                                        </span>
                                                                                    }
                                                                                >
                                                                                    <div className="mt-3">
                                                                                        {c.otherCharges != null && c.otherCharges.length > 0 && c.otherCharges.map((p, index) => {
                                                                                            return (
                                                                                                <Alert key={index} variant="primary" className="fade show">
                                                                                                    <Row>
                                                                                                        <Col md={10}>
                                                                                                            <h6 className="alert-heading font-18">
                                                                                                                {p.name}: <b>{currency.currencySuffix} {p.amount.toLocaleString()}</b>
                                                                                                            </h6>
                                                                                                        </Col>
                                                                                                        <Col md={2} className="text-right">
                                                                                                            {permissions.manageCustomerOrder === true && (
                                                                                                                <div className="d-flex justify-content-end">
                                                                                                                    <Button variant="warning" size="sm" className="me-1" onClick={(e) => {
                                                                                                                        setEditingCommercialInvoiceCostId(p.customerCommercialInvoiceShippingCostId)

                                                                                                                        setCommercialInvoiceCost((prevState) => ({
                                                                                                                            ...prevState,
                                                                                                                            customerCommercialInvoiceId: c.customerCommercialInvoiceId,
                                                                                                                            amount: p.amount,
                                                                                                                            shippingCostOptionId: p.shippingCostsOptionId,
                                                                                                                            shippingCostOptionName: p.name
                                                                                                                        }));

                                                                                                                        handleShowAddCommercialInvoiceCost();
                                                                                                                    }}><FiEdit /></Button>
                                                                                                                    <Button variant="danger" size="sm" onClick={() => {
                                                                                                                        setDeletingCommercialInvoiceCostId(p.customerCommercialInvoiceShippingCostId)
                                                                                                                        handleShowDeleteCommercialInvoiceCost();
                                                                                                                    }}><FiTrash2 /></Button>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Alert>
                                                                                            );
                                                                                        })}
                                                                                        {permissions.manageCustomerOrder === true && (
                                                                                            <Button variant="outline-danger" className="w-100" onClick={() => {
                                                                                                setEditingCommercialInvoiceCostId(0)
                                                                                                setCommercialInvoiceCost((prevState) => ({
                                                                                                    ...prevState,
                                                                                                    customerCommercialInvoiceId: c.customerCommercialInvoiceId,
                                                                                                    amount: 0,
                                                                                                    shippingCostOptionId: 0,
                                                                                                    shippingCostOptionName: ""
                                                                                                }));
                                                                                                handleShowAddCommercialInvoiceCost();
                                                                                            }}>
                                                                                                <b><FiPlus /> Add New Charge</b>
                                                                                            </Button>
                                                                                        )}
                                                                                    </div>
                                                                                </Tab>
                                                                                {/* <Tab
                                                                                    eventKey="payments"
                                                                                    title={
                                                                                        <span>
                                                                                            Payments{' '}
                                                                                            <Badge className="rounded-pill bg-primary badge">{c.payments?.length || 0}</Badge>
                                                                                            {
                                                                                                c.invoiceTotals?.productTotalPayment > 0 &&
                                                                                                <Badge className="rounded-pill bg-primary badge">{c.invoiceTotals?.productTotalPayment.toLocaleString() || 0}</Badge>
                                                                                            }
                                                                                        </span>
                                                                                    }
                                                                                >
                                                                                    <div className="mt-3">
                                                                                        {c.payments != null && c.payments.length > 0 && c.payments.map((p, index) => {
                                                                                            return (
                                                                                                <Alert key={index} variant="primary" className="fade show">
                                                                                                    <Row>
                                                                                                        <Col md={9}>
                                                                                                            <h6 className="alert-heading font-18">
                                                                                                                Amount: <b>{currency.currencySuffix} {p.paymentValue.toLocaleString()}</b>
                                                                                                            </h6>
                                                                                                            {p.notes && <span className="text-secondary"><i className="fas fa-pencil-alt" /> {p.notes}</span>}
                                                                                                        </Col>
                                                                                                        <Col md={3} className="text-right">
                                                                                                            <div className="d-flex justify-content-end">
                                                                                                                <h6 className="alert-heading font-14"><b>{p.invoiceDate.split("T")[0]}</b></h6>
                                                                                                            </div>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Alert>
                                                                                            );
                                                                                        })}
                                                                                        <Button variant="outline-primary" className="w-100" onClick={() => {
                                                                                            setCommercialInvoicePayment((prevState) => ({
                                                                                                ...prevState,
                                                                                                commercialInvoiceId: c.commercialInvoiceId,
                                                                                                commercialInvoiceNumber: c.invoiceNumber,
                                                                                                invoiceNumber: order.invoiceNumber,
                                                                                                remainingTotal: c.invoiceTotals.remainingTotal,
                                                                                                supplierName: supplierName,
                                                                                                supplierOrderId: order.supplierOrderId,
                                                                                                supplierAccountName: account.supplierAccount1,

                                                                                            }));
                                                                                            handleShowAddCommercialInvoicePayment();
                                                                                        }}>
                                                                                            <b><FiPlus /> Add New Payment</b>
                                                                                        </Button>
                                                                                    </div>
                                                                                </Tab>

                                                                                <Tab
                                                                                    eventKey="discounts"
                                                                                    title={
                                                                                        <span>
                                                                                        Discounts{' '}
                                                                                            <Badge className="rounded-pill bg-primary badge">{c.discounts?.length || 0}</Badge>
                                                                                            {
                                                                                                c.invoiceTotals?.productTotalDiscount > 0 &&
                                                                                                <Badge className="rounded-pill bg-primary badge">{c.invoiceTotals?.productTotalDiscount.toLocaleString() || 0}</Badge>
                                                                                            }
                                                                                        </span>
                                                                                    }
                                                                                >
                                                                                    <div className="mt-3">
                                                                                        {c.discounts != null && c.discounts.length > 0 && c.discounts.map((d, index) => {
                                                                                            return (
                                                                                                <Alert key={index} variant="primary" className="fade show">
                                                                                                    <Row>
                                                                                                        <Col md={9}>
                                                                                                            <h6 className="alert-heading font-18">
                                                                                                                Amount: <b>{currency.currencySuffix} {d.commercialInvoiceDiscount.toLocaleString()}</b>
                                                                                                            </h6>
                                                                                                            {d.notes && <span className="text-secondary"><i className="fas fa-pencil-alt" /> {d.notes}</span>}
                                                                                                        </Col>
                                                                                                        <Col md={3} className="text-right">
                                                                                                            <div className="d-flex justify-content-end">
                                                                                                                <h6 className="alert-heading font-14"><b>{d.discountDate.split("T")[0]}</b></h6>
                                                                                                            </div>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </Alert>
                                                                                            );
                                                                                        })}
                                                                                        <Button variant="outline-primary" className="w-100" onClick={() => {
                                                                                              setCommercialDiscount((prevState) => ({
                                                                                                ...prevState,
                                                                                                commercialInvoiceNumber: c.invoiceNumber,
                                                                                                remainingTotal: c.invoiceTotals.remainingTotal,
                                                                                                commercialInvoiceId: c.commercialInvoiceId,
                                                                                                commercialInvoiceDiscount: 0,
                                                                                                discountDate: formatDate(new Date()),
                                                                                                notes: "",
                                                                                                commercialInvoice: c.invoiceNumber,
                                                                                                proforma: order.invoiceNumber,
                                                                                                userId: localStorage.getItem("uTsReD"),
                                                                                                addToStatement: false
                                                                                            }));
                                                                                            handleShowAddCommercialDiscount();
                                                                                        }}>
                                                                                            <b><FiPlus /> Add New Discount</b>
                                                                                        </Button>
                                                                                    </div>
                                                                                </Tab> */}
                                                                            </Tabs>
                                                                        </Row>
                                                                    </Alert>
                                                                );
                                                            })}
                                                            {permissions.manageCustomerOrder === true && (
                                                                <Button variant="primary" className="w-100 mt-3" onClick={(e) => {
                                                                    setCustomerCommercialInvoice((prevState) => ({
                                                                        ...prevState,
                                                                        customerCommercialInvoice: "",
                                                                        customerCommercialInvoiceId: 0,
                                                                        notes: "",
                                                                        customerCommercialInvoiceDate: (new Date()).toISOString().split('T')[0],//.substring(0, 10),
                                                                    }))
                                                                    handleShowAddCustomerCommercialInvoice();
                                                                }}>
                                                                    <b><FiPlus /> Add New Invoice</b>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row >
                        <Col sm={12} style={{ flex: 1, display: 'flex' }}>
                            <Card style={{ flex: 1 }}>
                                <CardBody>
                                    <h5 className=" mb-3 alert-heading font-18"><i class="ion ion-md-attach" /> Attachments</h5>

                                    <Dropzone onDrop={handleAcceptedFiles}>
                                        {({ getRootProps, getInputProps }) => {
                                            const rootProps = getRootProps();
                                            const inputProps = getInputProps();

                                            return (
                                                <div {...rootProps}>
                                                    {permissions.manageCustomerOrder === true && (
                                                        <button
                                                            onClick={rootProps.onClick}
                                                            className="btn btn-primary mb-2 mt-3"
                                                            style={{ width: '100%' }}
                                                        >
                                                            <b><FiPlus /> Upload Attachments</b>
                                                        </button>
                                                    )}
                                                    <input {...inputProps} style={{ display: 'none' }} />
                                                </div>
                                            );
                                        }}
                                    </Dropzone>
                                    <br />
                                    <Row>
                                        {uploadedFiles.map((file, index) => (
                                            <Col sm={3} key={index} className="mb-1">
                                                <Card style={{ position: 'relative' }}>
                                                    {permissions.manageCustomerOrder === true && (
                                                        <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                                                            <button
                                                                className="btn btn-danger btn-md"
                                                                onClick={() => handleDelete(file.attachmentId)}
                                                            >
                                                                <FiTrash2 />
                                                            </button>
                                                        </div>
                                                    )}
                                                    <CardBody>
                                                        <span>{file.name}</span>
                                                        <div style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                {renderFilePreview(file)}
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </CardBody>

                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>

            <Modal size="md" show={showAddCommercialInvoiceCost} onHide={handleCloseAddCommercialInvoiceCost}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Charges</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Cost Type</label>
                            <Select
                                required
                                placeholder="-- Select Type --"
                                defaultValue={commercialInvoiceCost.shippingCostOptionName ? { label: commercialInvoiceCost.shippingCostOptionName, value: commercialInvoiceCost.shippingCostOptionId } : null}
                                isSearchable={true}
                                options={shippingCostTypes.map(f => ({
                                    value: f,
                                    label: f.name
                                }))}

                                valuekey
                                onChange={(e) => {
                                    setCommercialInvoiceCost((prevState) => ({
                                        ...prevState,
                                        shippingCostOptionId: e.value.shippingCostsOptionId,
                                        shippingCostOptionName: e.value.name,
                                    }));
                                }}>
                            </Select>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Amount</label>
                            <div className="input-group mb-3">
                                <span className="input-group-text">
                                    {currency.currencySuffix}
                                </span>

                                <input type="number" className="form-control" required
                                    value={commercialInvoiceCost.amount}
                                    // disabled={shippingCost.isPaid === true}
                                    onChange={(e) => {
                                        setCommercialInvoiceCost((prevState) => ({
                                            ...prevState,
                                            amount: e.target.value
                                        }))
                                    }}>
                                </input>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddCommercialInvoiceCost}>
                        Close
                    </Button>
                    <Button variant="primary"
                        disabled={submitDisabled} onClick={(e) =>
                            submitCommercialInvoiceCostForm(e)
                        }>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size="md" show={showDeleteCommercialInvoiceCost} onHide={handleCloseDeleteCommercialInvoiceCost}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Cost</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Are you sure you want to delete this cost?</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteCommercialInvoiceCost}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={(e) => DeleteCommercialInvoiceCost(deletingCommercialInvoiceCostId)}>
                        Yes, Proceed
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size="md" show={showDeleteAdvancedCharges} onHide={handleCloseDeleteAdvancedCharges}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Cost</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Are you sure you want to delete this cost?</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteAdvancedCharges}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={(e) => DeleteAdvancedCharges(deletingAdvancedChargesId)}>
                        Yes, Proceed
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showEditCustomerOrder} onHide={handleCloseEditCustomerOrder}>
                <Modal.Header closeButton>
                    <Modal.Title>Update info for #{order.invoiceNumber}
                        {/* <h5><small>Remaining Total: {currency.currencySuffix} {commercialDiscount.remainingTotal.toLocaleString()}</small></h5> */}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <label>Invoice Number</label>
                            <div className="input-group mb-3">
                                {/* <span className="input-group-text">{currency.currencySuffix}</span> */}
                                <input className="form-control"
                                    type="text"
                                    placeholder="Enter the invoice number"
                                    value={editingOrder.invoiceNumber}
                                    onChange={(e) => {
                                        setEditingOrder((prevState) => ({
                                            ...prevState,
                                            invoiceNumber: e.target.value
                                        }));
                                    }}>
                                </input>
                            </div>
                        </div>
                        <div className="col-12">
                            <label>Date</label>
                            <input className="form-control mb-3"
                                type="date"
                                value={editingOrder.date}
                                onChange={(e) => {
                                    setEditingOrder((prevState) => ({
                                        ...prevState,
                                        date: e.target.value
                                    }));
                                }}></input>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Payment Terms</label>
                            <Select
                                placeholder="-- Select Payment Terms --"
                                isSearchable={true}
                                value={editingOrder.paymentTermsId > 0 ? { label: editingOrder.paymentTermsName, value: editingOrder.paymentTermsId } : null}
                                options={paymentTerms.map(p => ({
                                    value: p,
                                    label: p.name
                                }))}
                                valuekey
                                onChange={(e) => {
                                    setEditingOrder((prevState) => ({
                                        ...prevState,
                                        paymentTermsId: e.value.paymentTermsId,
                                        paymentTermsName: e.value.name
                                    }))
                                }}>
                            </Select>
                        </div>
                        <div className="col-12">
                            <label>Commission (Per FCL)</label>
                            <div className="input-group mb-3">
                                <span className="input-group-text">{currency.currencySuffix}</span>
                                <input className="form-control"
                                    type="number"
                                    step="1"
                                    value={editingOrder.commission}
                                    placeholder="Commission (Optional)"
                                    onChange={(e) => {
                                        setEditingOrder((prevState) => ({
                                            ...prevState,
                                            commission: e.target.value
                                        }));
                                    }}>
                                </input>
                            </div>
                        </div>

                        <div className="col-12">
                            <label>Notes</label>
                            <textarea className="form-control"
                                placeholder="Your notes (Optional)"
                                value={editingOrder.notes}
                                onChange={(e) => {
                                    setEditingOrder((prevState) => ({
                                        ...prevState,
                                        notes: e.target.value
                                    }));
                                }}></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseEditCustomerOrder}>
                        Close
                    </button>
                    <button className="btn btn-primary" disabled={submitDisabled} onClick={(e) => submitCustomerOrderForm(e)}>
                        Save Changes
                    </button>
                </Modal.Footer>
            </Modal>


            {/* <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Commercial Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label>Invoice Number</label>
                            <input className="form-control" placeholder="Invoice Number" onChange={(e) => setCustomerCommercialInvoice((prevState) => ({
                                ...prevState, customerCommercialInvoice: e.target.value
                            }))}></input>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Supplier Commercial Invoice</label>
                            <Select
                                placeholder="-- Select Commercial Invoice --"
                                isSearchable={true}
                                options={supplierCommercialInvoices.map(x => ({
                                    value: x,
                                    label: x.invoiceNumber
                                }))}
                                valuekey
                                onChange={(e) => {
                                    setCustomerCommercialInvoice((prevState) => ({
                                        ...prevState, 
                                        supplierCommercialInvoiceId: e.value.commercialInvoiceId,
                                        customerCommercialInvoiceDate: e.value.date.split('T')[0]
                                    }))
                                }}></Select>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Date</label>
                            <input className="form-control" type="date" value={customerCommercialInvoice.customerCommercialInvoiceDate} onChange={(e) => setCustomerCommercialInvoice((prevState) => ({
                                ...prevState, customerCommercialInvoiceDate: e.target.value
                            }))}></input>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Notes</label>
                            <textarea className="form-control" placeholder="Notes"
                                onChange={(e) => setCustomerCommercialInvoice((prevState) => ({
                                    ...prevState, notes: e.target.value
                                }))}></textarea>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={(e) => AddCustomerCommercialInvoice(e)}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal> */}

            <Modal size="md" show={showDeleteCustomerOrder} onHide={handleCloseDeleteCustomerOrder}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Order #{order.invoiceNumber}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Are you sure you want to delete this order?</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteCustomerOrder}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={(e) => DeleteCustomerOrder()}>
                        Yes, Proceed
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal size="md" show={showDeleteCustomerOrderProduct} onHide={handleCloseDeleteCustomerOrderProduct}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Order #{order.invoiceNumber}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Are you sure you want to delete this product?</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteCustomerOrderProduct}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={(e) => DeleteCustomerOrderProduct()}>
                        Yes, Proceed
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showAddOrderProduct} onHide={handleCloseAddOrderProduct}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingOrder > 0 ? "Edit Order Product" : "Add Order Product"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <label>Supplier</label>
                            {editingProductId > 0 ?
                                <Select
                                    placeholder="-- Select Supplier --"
                                    isSearchable={true}
                                    isDisabled={true}
                                    defaultValue={{ label: orderProduct.supplierName, value: orderProduct.supplierId }}
                                    options={suppliers.map(c => ({
                                        value: c,
                                        label: c.supplierName
                                    }))}
                                    valuekey
                                    onChange={(e) => {
                                        handleSupplierChange(e.value.supplierId);
                                        setOrderProduct((prevState) => ({
                                            ...prevState,
                                            supplierName: e.value.supplierName
                                        }))
                                    }}>
                                </Select>
                                :
                                <Select
                                    placeholder="-- Select Supplier --"
                                    isSearchable={true}
                                    options={suppliers.map(c => ({
                                        value: c,
                                        label: c.supplierName
                                    }))}
                                    valuekey
                                    onChange={(e) => {
                                        handleSupplierChange(e.value.supplierId);
                                        setOrderProduct((prevState) => ({
                                            ...prevState,
                                            supplierName: e.value.supplierName
                                        }))
                                    }}>
                                </Select>
                            }

                            <label className="mt-3">Products</label>
                            {editingProductId > 0 ?
                                <Select
                                    placeholder="-- Select Supplier Product --"
                                    isSearchable={true}
                                    isDisabled={true}
                                    defaultValue={{ label: orderProduct.productDescription, value: orderProduct.supplierOrderProductId }}
                                    options={supplierOrderProducts.map(c => ({
                                        value: c,
                                        label: ('#' + c.supplierOrders.invoiceNumber + ' - ' + c.productName + ', ' + c.productSizeName + ', ' + c.productTypeName + ' (' + c.supplierOrderProducts.pendingFcl + ' FCL / ' + c.supplierOrderProducts.pendingQuantity + ' ' + c.productUnit1 + ') (' + c.currency.currencySuffix + ' ' + c.supplierOrderProducts.unitPrice + ')')
                                    }))}
                                    valuekey
                                    // value={{label: orderProduct.productDescription, value: orderProduct.supplierOrderProductId}}
                                    onChange={(e) => {
                                        setOrderProduct((prevState) => ({
                                            ...prevState,
                                            supplierOrderProductId: e.value.supplierOrderProductId,
                                            productDescription: e.value.productName,
                                            pendingQuantity: e.value.pendingQuantity,
                                            pendingFcl: e.value.pendingFcl,
                                            productUnitName: e.value.productUnit1,
                                            exchangeRate: 1.0
                                        }));
                                        handleCustomerAccountOrderProduct(e.value.supplierOrderProductId);
                                    }}>
                                </Select>
                                :
                                <Select
                                    placeholder="-- Select Supplier Product --"
                                    isSearchable={true}
                                    options={supplierOrderProducts.map(c => ({
                                        value: c,
                                        label: ('#' + c.supplierOrders.invoiceNumber + ' - ' + c.productName + ', ' + c.productSizeName + ', ' + c.productTypeName + ' (' + c.supplierOrderProducts.pendingFcl + ' FCL / ' + c.supplierOrderProducts.pendingQuantity + ' ' + c.productUnit1 + ') (' + c.currency.currencySuffix + ' ' + c.supplierOrderProducts.unitPrice + ')')
                                    }))}
                                    valuekey
                                    // value={{label: orderProduct.productDescription, value: orderProduct.supplierOrderProductId}}
                                    onChange={(e) => {
                                        setOrderProduct((prevState) => ({
                                            ...prevState,
                                            supplierOrderProductId: e.value.supplierOrderProducts.supplierOrderProductId,
                                            productDescription: e.value.supplierOrderProducts.productName,
                                            pendingQuantity: e.value.supplierOrderProducts.pendingQuantity,
                                            pendingFcl: e.value.supplierOrderProducts.pendingFcl,
                                            currencySuffix: e.value.currency.currencySuffix,
                                            currencyId: e.value.currency.currencyId,
                                            productUnitName: e.value.productUnit1,
                                            exchangeRate: 1.0
                                        }));
                                        setSameCurrency(e.value.currency.currencyId == currency.currencyId);
                                        handleCustomerAccountOrderProduct(e.value.supplierOrderProducts.supplierOrderProductId);
                                    }}>
                                </Select>
                            }
                            {/* <label>
                                {orderProduct.supplierOrderProductId}
                            </label> */}

                            {(sameCurrency == false) ? (
                                <>
                                    <div className="row mb-3 mt-3">
                                        <div className="col-6">
                                            <label>{orderProduct.currencySuffix} to {currency.currencySuffix} Exchange Rate <i class="fas fa-info-circle" id="tooltip1" />
                                                <UncontrolledTooltip placement="top" target="tooltip1">
                                                    Since this client account currency is different than the supplier invoice currency, the exchange rate is required.
                                                </UncontrolledTooltip></label>
                                            <input type="number" className="form-control" required
                                                value={orderProduct.exchangeRate}
                                                step={0.1}
                                                onChange={(e) => {
                                                    setOrderProduct((prevState) => ({
                                                        ...prevState,
                                                        exchangeRate: e.target.value
                                                    }));
                                                }}>
                                            </input>
                                            {/* <span class="bg-warning badge badge-warning"> */}
                                            {/* <div>
                                                <i class="typcn typcn-info bg-warning badge badge-warning">Since the forwarder account currency is different than the supplier<br/>invoice currency, the exchange rate is required in order to calculate the profit.</i>
                                            </div> */}
                                            {/* </span> */}
                                        </div>
                                        <div className="col-6">
                                            <label>Number of Containers</label>
                                            <input type="number" className="form-control"
                                                value={orderProduct.fcl}
                                                min={0}
                                                max={orderProduct.pendingFcl}
                                                onChange={(e) => {
                                                    setOrderProduct((prevState) => ({
                                                        ...prevState,
                                                        fcl: e.target.value
                                                    }));
                                                }}></input>
                                        </div>
                                    </div>
                                </>
                            ) :

                                <div className="row mb-3 mt-3">
                                    <div className="col-6">
                                        <label>Number of Containers</label>
                                        <input type="number" className="form-control"
                                            value={orderProduct.fcl}
                                            onChange={(e) => {
                                                setOrderProduct((prevState) => ({
                                                    ...prevState,
                                                    fcl: e.target.value
                                                }));
                                            }}></input>
                                    </div>
                                </div>
                            }

                            <div className="row ">
                                <div className="col-6">
                                    <label>Quantity ({orderProduct.productUnitName})</label>
                                    <input type="number" className="form-control"
                                        value={orderProduct.productQuantity.toLocaleString()}
                                        onChange={(e) => {
                                            setOrderProduct((prevState) => ({
                                                ...prevState,
                                                productQuantity: e.target.value
                                            }));
                                            // setCustomerAccountOrderProduct((prevState) => ({
                                            //     ...prevState,
                                            //     quantity: e.target.value,
                                            // }));
                                        }}></input>
                                </div>
                                <div className="col-6">
                                    <label>Unit Price</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-text">{currency.currencySuffix}</div>
                                        <input type="number" className="form-control"
                                            value={orderProduct.unitPrice}
                                            onChange={(e) => {
                                                setOrderProduct((prevState) => ({
                                                    ...prevState,
                                                    unitPrice: e.target.value
                                                }));
                                            }}></input>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseAddOrderProduct}>
                        Close
                    </button>
                    <button className="btn btn-primary" disabled={submitDisabled} onClick={(e) => {
                        if (editingProductId > 0) {
                            // handleCustomerAccountOrderProduct(orderProduct.supplierOrderProductId);
                            EditOrderProduct(e)
                        }
                        else {
                            AddOrderProduct(e)
                        }
                    }}>
                        Save Changes
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showAddCustomerCommercialInvoice} onHide={handleCloseAddCustomerCommercialInvoice}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Commercial Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label>Invoice Number</label>
                            <input className="form-control" placeholder="Invoice Number" onChange={(e) => setCustomerCommercialInvoice((prevState) => ({
                                ...prevState, customerCommercialInvoice: e.target.value
                            }))}></input>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Supplier Commercial Invoice</label>
                            <Select
                                placeholder="-- Select Commercial Invoice --"
                                isSearchable={true}
                                options={supplierCommercialInvoices.map(x => ({
                                    value: x,
                                    label: x.invoiceNumber
                                }))}
                                valuekey
                                onChange={(e) => {
                                    setCustomerCommercialInvoice((prevState) => ({
                                        ...prevState,
                                        supplierCommercialInvoiceId: e.value.commercialInvoiceId,
                                        customerCommercialInvoiceDate: e.value.date.split('T')[0]
                                    }))
                                }}></Select>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Date</label>
                            <input className="form-control" type="date" value={customerCommercialInvoice.customerCommercialInvoiceDate} onChange={(e) => setCustomerCommercialInvoice((prevState) => ({
                                ...prevState, customerCommercialInvoiceDate: e.target.value
                            }))}></input>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Notes</label>
                            <textarea className="form-control" placeholder="Notes"
                                onChange={(e) => setCustomerCommercialInvoice((prevState) => ({
                                    ...prevState, notes: e.target.value
                                }))}></textarea>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddCustomerCommercialInvoice}>
                        Close
                    </Button>
                    <Button variant="primary" disabled={submitDisabled} onClick={(e) => AddCustomerCommercialInvoice(e)}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showEditCommercialInvoice} onHide={handleCloseEditCommercialInvoice}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Commercial Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label>Invoice Number</label>
                            <input className="form-control"
                                placeholder="Invoice Number"
                                value={editingCommercialInvoice.customerCommercialInvoice}
                                onChange={(e) => setEditingCommercialInvoice((prevState) => ({
                                    ...prevState, customerCommercialInvoice: e.target.value
                                }))}></input>
                        </div>
                        {/* <div className="col-12 mb-3">
                            <label>Supplier Commercial Invoice</label>
                            <Select
                                placeholder="-- Select Commercial Invoice --"
                                isSearchable={true}
                                options={commercialInvoices.map(x => ({
                                    value: x,
                                    label: x.invoiceNumber
                                }))}
                                valuekey
                                onChange={(e) => {
                                    setEditingCommercialInvoice((prevState) => ({
                                        ...prevState, 
                                        supplierCommercialInvoiceId: e.value.commercialInvoiceId,
                                        customerCommercialInvoiceDate: e.value.date.split('T')[0]
                                    }))
                                }}></Select>
                        </div> */}
                        <div className="col-12 mb-3">
                            <label>Date</label>
                            <input className="form-control" type="date"
                                value={editingCommercialInvoice.customerCommercialInvoiceDate}
                                onChange={(e) => setEditingCommercialInvoice((prevState) => ({
                                    ...prevState, customerCommercialInvoiceDate: e.target.value
                                }))}></input>
                        </div>
                        <div className="col-12 mb-3">
                            <label>Notes</label>
                            <textarea className="form-control"
                                placeholder="Notes"
                                value={editingCommercialInvoice.notes}
                                onChange={(e) => setEditingCommercialInvoice((prevState) => ({
                                    ...prevState, notes: e.target.value
                                }))}></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditCommercialInvoice}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={(e) => EditCustomerCommercialInvoice(e)}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size="md" show={showDeleteCommercialInvoice} onHide={handleCloseDeleteCommercialInvoice}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Commercial Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Are you sure you want to delete commercial invoice #{deletingCommercialInvoice}?</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteCommercialInvoice}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={(e) => submitDeleteInvoiceForm(e)}>
                        Yes, Proceed
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showAddAdvancedPayment} onHide={handleCloseAddAdvancedPayment}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Payment for {order.invoiceNumber}
                        {(orderTotal != null && orderTotal.remainingTotalAmount != null) &&
                            <h5><small>Pending Due Total: {orderTotal.remainingTotalAmount.toLocaleString() + " " + currency.currencySuffix}</small></h5>
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <>
                            <div className="col-6">
                                <label>Amount</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text">{currency.currencySuffix}</span>
                                    <input type="number" className="form-control" required
                                        value={advancedPayment.amount}
                                        onChange={(e) => {
                                            setAdvancedPayment((prevState) => ({
                                                ...prevState,
                                                amount: e.target.value
                                            }));
                                            reloadBankAmount(e.target.value)
                                        }}>
                                    </input>
                                </div>
                            </div>
                            <div className="col-6">
                                <label>Percentage</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text">%</span>
                                    <input type="number" className="form-control" required
                                        value={advancedPayment.paymentPercentage}
                                        onChange={(e) => {
                                            setAdvancedPayment((prevState) => ({
                                                ...prevState,
                                                paymentPercentage: e.target.value
                                            }));
                                            reloadAmountFromPercentage(e.target.value)
                                        }}>
                                    </input>
                                </div>
                            </div>
                        </>
                        <div className="col-12">
                            <label>Date</label>
                            <input className="form-control mb-3" type="date" value={advancedPayment.date}
                                onChange={(e) => {
                                    setAdvancedPayment((prevState) => ({
                                        ...prevState,
                                        date: e.target.value
                                    }));
                                }} />
                        </div>
                        <div className="col-12">
                            <label>Bank</label>
                            <select className="form-control mb-3" value={advancedPayment.bankId}
                                onChange={(e) => {
                                    setAdvancedPayment((prevState) => ({
                                        ...prevState,
                                        bankId: e.target.value
                                    }));
                                    setBankAccounts([])
                                    GetBankAccounts(e.target.value);
                                }}>
                                <option value="">-- Select Bank --</option>
                                {banks.map((b) => (
                                    <option value={b.bankId}>{b.bankName}</option>
                                )

                                )}
                            </select>
                        </div>
                        <div className="col-12">
                            <label>Bank Account</label>
                            <select className="form-control mb-3" value={advancedPayment.bankAccountId}
                                onChange={(e) => {
                                    setAdvancedPayment((prevState) => ({
                                        ...prevState,
                                        bankAccountId: e.target.value
                                    }));
                                    const bankAccount = bankAccounts.find(x => x.bankAccountId === Number(e.target.value));
                                    if (bankAccount) {
                                        setSameCurrency(bankAccount.currencyId == currency.currencyId);
                                        setBankCurrency(bankAccount.currencySuffix)
                                        if (bankAccount.currencyId == currency.currencyId) {
                                            setAdvancedPayment((prevState) => ({
                                                ...prevState,
                                                bankExchange: 1,
                                                bankAmount: advancedPayment.amount
                                            }))
                                        }
                                    } else {
                                        setSameCurrency(true);
                                        setAdvancedPayment((prevState) => ({
                                            ...prevState,
                                            bankExchange: 1,
                                            bankAmount: advancedPayment.amount
                                        }))
                                    }
                                }}>
                                <option value="">-- Select Bank Account --</option>
                                {bankAccounts.map((b) => (
                                    <option key={b.bankAccountId} value={b.bankAccountId}>{b.bankAccount1}</option>
                                ))}
                            </select>
                        </div>
                        {sameCurrency == false && (
                            <>
                                <div className="col-6">
                                    <label>Amount in Bank</label>
                                    <div className="input-group  mb-3">
                                        <span class="input-group-text">{bankCurrency}</span>
                                        <input type="number" className="form-control" required
                                            value={advancedPayment.bankAmount}
                                            onChange={(e) => {
                                                setAdvancedPayment((prevState) => ({
                                                    ...prevState,
                                                    bankAmount: e.target.value
                                                }));
                                                handleExchangeRate(e.target.value)
                                            }}>
                                        </input>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <label>Exchange Rate</label>
                                    <input type="number" className="form-control mb-3" required
                                        value={advancedPayment.bankExchange}
                                        onChange={(e) => {
                                            setAdvancedPayment((prevState) => ({
                                                ...prevState,
                                                bankExchange: e.target.value
                                            }));
                                            handleBankAmount(e.target.value)
                                        }}>
                                    </input>
                                </div>
                            </>
                        )}

                        <div className="col-12">
                            <label>Notes</label>
                            <textarea className="form-control"
                                onChange={(e) => {
                                    setAdvancedPayment((prevState) => ({
                                        ...prevState,
                                        notes: e.target.value
                                    }));
                                }}></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseAddAdvancedPayment}>
                        Close
                    </button>
                    <button className="btn btn-primary" onClick={(e) => AddAdvancedPayments(e)}>
                        Save Changes
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Edit Payment Modal */}
            <Modal show={showEditAdvancedPayment} onHide={handleCloseEditAdvancedPayment}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Payment for {order.invoiceNumber}
                        {(orderTotal != null && orderTotal.remainingTotalAmount != null) &&
                            <h5><small>Pending Due Total: {orderTotal.remainingTotalAmount.toLocaleString() + " " + currency.currencySuffix}</small></h5>
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <>
                            <div className="col-6">
                                <label>Amount</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text">{currency.currencySuffix}</span>
                                    <input type="number" className="form-control" required
                                        value={editingPayment.amount}
                                        onChange={(e) => {
                                            setEditingPayment((prevState) => ({
                                                ...prevState,
                                                amount: e.target.value
                                            }));
                                            reloadBankAmountEdit(e.target.value)
                                        }}>
                                    </input>
                                </div>
                            </div>
                            <div className="col-6">
                                <label>Percentage</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text">%</span>
                                    <input type="number" className="form-control" required
                                        value={editingPayment.paymentPercentage}
                                        onChange={(e) => {
                                            setEditingPayment((prevState) => ({
                                                ...prevState,
                                                paymentPercentage: e.target.value
                                            }));
                                            reloadAmountFromPercentageEdit(e.target.value)
                                        }}>
                                    </input>
                                </div>
                            </div>
                        </>
                        <div className="col-12">
                            <label>Date</label>
                            <input className="form-control mb-3" type="date" value={editingPayment.date}
                                onChange={(e) => {
                                    setEditingPayment((prevState) => ({
                                        ...prevState,
                                        date: e.target.value
                                    }));
                                }} />
                        </div>
                        <div className="col-12">
                            <label>Bank</label>
                            <select className="form-control mb-3" value={editingPayment.bankId}
                                onChange={(e) => {
                                    setEditingPayment((prevState) => ({
                                        ...prevState,
                                        bankId: e.target.value
                                    }));
                                    setBankAccounts([])
                                    GetBankAccounts(e.target.value);
                                }}>
                                <option value="">-- Select Bank --</option>
                                {banks.map((b) => (
                                    <option key={b.bankId} value={b.bankId}>{b.bankName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12">
                            <label>Bank Account</label>
                            <select className="form-control mb-3" value={editingPayment.bankAccountId}
                                onChange={(e) => {
                                    setEditingPayment((prevState) => ({
                                        ...prevState,
                                        bankAccountId: e.target.value
                                    }));
                                    const bankAccount = bankAccounts.find(x => x.bankAccountId === Number(e.target.value));
                                    if (bankAccount) {
                                        setSameCurrency(bankAccount.currencyId == currency.currencyId);
                                        setBankCurrency(bankAccount.currencySuffix)
                                        if (bankAccount.currencyId == currency.currencyId) {
                                            setEditingPayment((prevState) => ({
                                                ...prevState,
                                                bankExchange: 1,
                                                bankAmount: editingPayment.amount
                                            }))
                                        } else {
                                            setEditingPayment((prevState) => ({
                                                ...prevState,
                                                bankExchange: bankAccount.bankExchange || 1,
                                                bankAmount: editingPayment.amount * (bankAccount.bankExchange || 1)
                                            }))
                                        }
                                    } else {
                                        setSameCurrency(true);
                                        setEditingPayment((prevState) => ({
                                            ...prevState,
                                            bankExchange: 1,
                                            bankAmount: editingPayment.amount
                                        }))
                                    }
                                }}>
                                <option value="">-- Select Bank Account --</option>
                                {bankAccounts.map((b) => (
                                    <option key={b.bankAccountId} value={b.bankAccountId}>{b.bankAccount1}</option>
                                ))}
                            </select>
                        </div>
                        {sameCurrency == false && (
                            <>
                                <div className="col-6">
                                    <label>Amount in Bank</label>
                                    <div className="input-group  mb-3">
                                        <span class="input-group-text">{bankCurrency}</span>
                                        <input type="number" className="form-control" required
                                            value={editingPayment.bankAmount}
                                            onChange={(e) => {
                                                setEditingPayment((prevState) => ({
                                                    ...prevState,
                                                    bankAmount: e.target.value
                                                }));
                                            }}>
                                        </input>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <label>Exchange Rate</label>
                                    <input type="number" className="form-control mb-3" required
                                        value={editingPayment.bankExchange}
                                        onChange={(e) => {
                                            setEditingPayment((prevState) => ({
                                                ...prevState,
                                                bankExchange: e.target.value
                                            }));
                                            handleBankAmountEdit(e.target.value)
                                        }}>
                                    </input>
                                </div>
                            </>
                        )}

                        <div className="col-12">
                            <label>Notes</label>
                            <textarea className="form-control"
                                value={editingPayment.notes}
                                onChange={(e) => {
                                    setEditingPayment((prevState) => ({
                                        ...prevState,
                                        notes: e.target.value
                                    }));
                                }}></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseEditAdvancedPayment}>
                        Close
                    </button>
                    <button className="btn btn-primary" onClick={(e) => EditAdvancedPayment(e)}>
                        Save Changes
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showAdvancedDiscount} onHide={handleCloseAdvancedDiscount}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Advanced Discount</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <label>Advanced Value</label>
                            <input type="number" className="form-control mb-3" required
                                onChange={(e) => {
                                    setAdvancedDiscount((prevState) => ({
                                        ...prevState,
                                        advancedDiscount: e.target.value
                                    }));
                                }}>
                            </input>
                        </div>
                        <div className="col-12">
                            <label>Date</label>
                            <input className="form-control mb-3" type="date"
                                value={advancedDiscount.discountDate}
                                onChange={(e) => setAdvancedDiscount((prevState) => ({
                                    ...prevState,
                                    discountDate: e.target.value
                                }))}></input>
                        </div>
                        <div className="col-12">
                            <label>Notes</label>
                            <textarea className="form-control"
                                onChange={(e) => {
                                    setAdvancedDiscount((prevState) => ({
                                        ...prevState,
                                        notes: e.target.value
                                    }));
                                }}></textarea>
                        </div>
                        <div className="col-12" class="form-check form-switch form-switch-md mt-3 ms-3">
                            <input className="form-check-input" type="checkbox" id="customSwitch2" checked={advancedDiscount.addToStatement}
                                onChange={(e) =>
                                    setAdvancedDiscount((prevState) => ({
                                        ...prevState, addToStatement: e.target.checked
                                    })
                                    )} />
                            <label class="form-check-label" for="customSwitch2">Add discount to account statement</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseAdvancedDiscount}>
                        Close
                    </button>
                    <button className="btn btn-primary" onClick={(e) => AddAdvancedDiscount(e)}>
                        Save Changes
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showEditAdvancedDiscount} onHide={handleCloseEditAdvancedDiscount}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Advanced Discount</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <label>Advanced Value</label>
                            <input 
                                type="number" 
                                className="form-control mb-3" 
                                required
                                value={editingDiscount.advancedDiscount}
                                onChange={(e) => {
                                    setEditingDiscount((prevState) => ({
                                        ...prevState,
                                        advancedDiscount: parseFloat(e.target.value) || 0
                                    }));
                                }}
                            />
                        </div>
                        <div className="col-12">
                            <label>Date</label>
                            <input 
                                className="form-control mb-3" 
                                type="date"
                                value={editingDiscount.discountDate}
                                onChange={(e) => setEditingDiscount((prevState) => ({
                                    ...prevState,
                                    discountDate: e.target.value
                                }))}
                            />
                        </div>
                        <div className="col-12">
                            <label>Notes</label>
                            <textarea 
                                className="form-control"
                                value={editingDiscount.notes}
                                onChange={(e) => {
                                    setEditingDiscount((prevState) => ({
                                        ...prevState,
                                        notes: e.target.value
                                    }));
                                }}
                            />
                        </div>
                        <div className="col-12" class="form-check form-switch form-switch-md mt-3 ms-3">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id="customSwitchEdit" 
                                checked={editingDiscount.addToStatement}
                                onChange={(e) =>
                                    setEditingDiscount((prevState) => ({
                                        ...prevState, 
                                        addToStatement: e.target.checked
                                    }))
                                } 
                            />
                            <label class="form-check-label" for="customSwitchEdit">Add discount to account statement</label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseEditAdvancedDiscount}>
                        Close
                    </button>
                    <button className="btn btn-primary" onClick={(e) => EditAdvancedDiscount(e)}>
                        Save Changes
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal size="md" show={showAddAdvancedCharges} onHide={handleCloseAddAdvancedCharges}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Charges</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Charges Type</label>
                            <Select
                                required
                                placeholder="-- Select Type --"
                                defaultValue={advancedCharges.shippingCostOptionName ? { label: advancedCharges.shippingCostOptionName, value: advancedCharges.shippingCostOptionId } : null}
                                isSearchable={true}
                                options={shippingCostTypes.map(f => ({
                                    value: f,
                                    label: f.name
                                }))}

                                valuekey
                                onChange={(e) => {
                                    setAdvancedCharges((prevState) => ({
                                        ...prevState,
                                        shippingCostOptionId: e.value.shippingCostsOptionId,
                                        shippingCostOptionName: e.value.name,
                                    }));
                                }}>
                            </Select>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <div className="col-12">
                            <label>Amount</label>
                            <div className="input-group mb-3">
                                <span className="input-group-text">
                                    {currency.currencySuffix}
                                </span>

                                <input type="number" className="form-control" required
                                    value={advancedCharges.amount}
                                    // disabled={shippingCost.isPaid === true}
                                    onChange={(e) => {
                                        setAdvancedCharges((prevState) => ({
                                            ...prevState,
                                            amount: e.target.value
                                        }))
                                    }}>
                                </input>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddAdvancedCharges}>
                        Close
                    </Button>
                    <Button variant="primary"
                        disabled={submitDisabled} onClick={(e) =>
                            submitAdvancedChargesForm(e)
                        }>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>)
}
export default ViewCustomerOrder